var bts = angular.module("bootstrap.employer", []);
bts.run(['link', 'navigation', 'brand', 'sessionData', 'hook', '$state', 'brandConfig', function (link, navigation, brand, sessionData, hook, $state, brandConfig) {
    hook.register('eBusinessSessionStart', ['brand', 'services', 'sessionData', 'brandConfig', 'appConfig', '$q',
        function (brand, services, sessionData, brandConfig, appConfig, $q) {

            var hostnameArray = window.location.hostname.split('.');
            console.log(hostnameArray)
            var subDomain = hostnameArray[0];
            var currentConfig = subDomain.includes("tenv")?subDomain:"";
            //console.log(window.location.href.indexOf('employer'))
            if(sessionData.basicInfo && sessionData.basicInfo.role != 'MEMBER' && window.location.href.indexOf('employer') >= 0 && sessionData.basicInfo.companyCode=="NDBCBS")
            {                
            window.open("https://employer"+currentConfig+".bcbsndportals.com/login/nd",'_self','noopener,noreferrer');
            }
            if(sessionData.basicInfo && sessionData.basicInfo.role != 'MEMBER' && window.location.href.indexOf('employer') >= 0 && sessionData.basicInfo.companyCode=="WYBCBS")
            {
                window.open("https://employer"+currentConfig+".yourwyoblue.com/login/wy",'_self','noopener,noreferrer');
            }

            if (
                ["ba", "bacancelled", "agent", "agency_admin", "sba","mcu_admin"].indexOf(sessionData.basicInfo.role.toLowerCase()) >= 0 &&
                // what's below is awful but currently necessary until we can establish exclusive roles between employer and plan advisor
                window.location.href.search(/medicare.*\./) === -1 &&
                (window.location.href.indexOf('find-a-doctor') === -1 || window.location.href.indexOf('employer') >= 0)
            ) {
                if (sessionData.basicInfo.role.toLowerCase().indexOf("mcu_admin") >= 0) {

                    sessionData.tempPassword = sessionData.basicInfo.temporaryPasswordFlag;
                    var be = localStorage.getItem('clientNumber');
                    var ce = localStorage.getItem('clientSelected');
                    sessionData.clientNumber = be;
                    return $q.all(
                        {
                            employerInfo: services.eprsvc.employerInfo().fetchMCU(sessionData.clientNumber || be),
                            additionalClientInfo: (sessionData.clientSelected || ce) ? services.eprsvc.additionalClientInformation().fetch(sessionData.clientNumber || be) : null,
                            appConfigEmployerResponse: appConfig.get('EMPLOYER'),
                            appConfigProviderResponse: appConfig.get('PROVIDER')
                        }
                    ).then(
                        function (responses) {
                            var employerInfo = responses.employerInfo;
                            var empInfo = employerInfo && employerInfo.data && employerInfo.data.payload && employerInfo.data.payload;
                            sessionData.employerInfo = empInfo;

                            sessionData.basicInfo.lastName = empInfo.planAdministrator && empInfo.planAdministrator.lastName;
                            brand.override = brandConfig.getSharedBrandCodeFromLeafUBK(sessionData.employerInfo.brandName);
                            brandConfig.update();

                            if(!sessionData.hasOwnProperty('clientSelected')){
                                sessionData.clientSelected = false;
                            }
                            //sessionData.clientSelected = ce;
                            //MOved here for future Use
                            sessionData.isClientselection = true;
                            var additionalClientInfo = responses.additionalClientInfo;
                            additionalClientInfo = additionalClientInfo && additionalClientInfo.data && additionalClientInfo.data.payload;


                            sessionData.appConfig = angular.extend({}, responses.appConfigEmployerResponse);
                            sessionData.appConfig.PROVIDER = responses.appConfigProviderResponse;
                            if(sessionData.clientSelected || ce){
                                console.log("in Client seletcetc")
                                return $q.when(services.eprsvc.employerInfo().setEntitlements(empInfo, additionalClientInfo)).then( // $q.when because setEntitlements may call RBSMBL's employerInfo
                                                                                                                                    function (entitlements) {

                                                                                                                                        sessionData.entitlements = entitlements;
                                                                                                                                        setEmployerLinks();
                                                                                                                                        console.log("waiting if completed")
                                                                                                                                    }
                                );
                            }
                            else {
                                console.log("in MCU set links")

                                return setMCUEmployerLinks();
                            }

                        },
                        function () { // service failed, happens for Producers... allegedly
                            return appConfig.getAll().then(function (appConfigResponse) {
                                sessionData.appConfig = angular.extend({}, appConfigResponse);
                            });
                        }
                    );
                    //removed commented code here that is not needed.



                    //})
                }

                else {
                    sessionData.tempPassword = sessionData.basicInfo.temporaryPasswordFlag;
                    return $q.all(
                        {
                            employerInfo: services.eprsvc.employerInfo().fetch(),
                            additionalClientInfo: services.eprsvc.additionalClientInformation().fetch(),
                            appConfigEmployerResponse: appConfig.get('EMPLOYER'),
                            appConfigProviderResponse: appConfig.get('PROVIDER')
                        }
                    ).then(
                        function (responses) {

                            var employerInfo = responses.employerInfo;
                            employerInfo = employerInfo && employerInfo.data && employerInfo.data.payload && employerInfo.data.payload;
                            if (employerInfo && employerInfo.brandName) {
                                brand.override = brandConfig.getSharedBrandCodeFromLeafUBK(employerInfo.brandName);
                                //$cookies.put('brand', brand.override);
                                sessionData.employerInfo = employerInfo;
                                sessionData.basicInfo.lastName = employerInfo.planAdministrator && employerInfo.planAdministrator.lastName;
                                if (employerInfo.brandName == 6008 || employerInfo.brandName == 6009) {
                                    delete sessionData.tempPassword;
                                }
                            }
                            else {
                                console.error('There was no brandName property in the response. It is possible that Plan Area code is not configured in the database.');
                            }

                            if (window.ContextHub) {
                                window.ContextHub.setItem("profile", $.extend(window.ContextHub.getItem("profile"), { brandName: employerInfo.brandName }));
                            }

                            brandConfig.update();

                            var additionalClientInfo = responses.additionalClientInfo;
                            additionalClientInfo = additionalClientInfo && additionalClientInfo.data && additionalClientInfo.data.payload;

                            sessionData.appConfig = angular.extend({}, responses.appConfigEmployerResponse);
                            sessionData.appConfig.PROVIDER = responses.appConfigProviderResponse;

                            return $q.when(services.eprsvc.employerInfo().setEntitlements(employerInfo, additionalClientInfo)).then( // $q.when because setEntitlements may call RBSMBL's employerInfo
                                                                                                                                     function (entitlements) {
                                                                                                                                         sessionData.entitlements = entitlements;
                                                                                                                                         setEmployerLinks();
                                                                                                                                     }
                            );
                        },
                        function () { // service failed, happens for Producers... allegedly
                            return appConfig.getAll().then(function (appConfigResponse) {
                                sessionData.appConfig = angular.extend({}, appConfigResponse);
                            });
                        }
                    );}

            }
        }
    ]);


    function setEmployerLinks() {
        var mapUBKs = brandConfig.mapLeafUBKsToSharedBrandCodes.bind(brandConfig);

        // region LINKS, Blue Nav Bar and others ====================================================
        var employerPostPasswordHomeLink = link.set("employerPostPasswordHome", {
            "state": "home",
            "url": "/employer/home",
            "label": "",
            "icon": true,
            "filterData": {
                "brand": ['*'],
                "portal": "employer",
                "postPassword": true,
                "entitlement": "*"
            }
        });

        var enrollmentLink = link.set("enrollmentLink", {
            state: "employee.enrollment",
            url: "/employer/manage-employees/enrollment",
            label: "Enrollment",
            filterData: {
                brand: ['*'],
                portal: "employer",
                postPassword: true,
                entitlement: "sessionData.entitlements.employees.view"
            }
        });

        // region Quick Links - the yellow banner on the home page ========================================
        //	addEmployeeLink, findEmployeeLink, enrollmentsInProcessLink, idCardsLink, groupContractsLink, masterGroupContractsLink, benefitBookletsLink

        var addEmployeeLink = link.set('addEmployeeLink', {
            state: 'employee.add.subscriber',
            label: 'Add Employee',
            coremetricsParams: {
                elementId: 'QUICK LINKS ADD EMPLOYEE',
                theCategory: 'EMPLOYERS:HOME PAGE:EMPLOYER LANDING PAGE'
            },
            filterData: {
                brand: ['*'],
                portal: 'employer',
                postPassword: true,
                entitlement: 'sessionData.entitlements.employees.edit && sessionData.entitlements.clientStatus.active'
            }
        });

        var findEmployeeLink = link.set('findEmployeeLink', {
            state: 'employee.find',
            label: 'Find Employee',
            coremetricsParams: {
                elementId: 'QUICK LINKS FIND EMPLOYEE',
                theCategory: 'EMPLOYERS:HOME PAGE'
            },
            filterData: {
                brand: ['*'],
                portal: 'employer',
                postPassword: true,
                entitlement: 'sessionData.entitlements.employees.view'
            }
        });

        var enrollmentsInProcessLink = link.set('enrollmentsInProcessLink', {
            state: 'employee.enrollmentsInProcess',
            label: 'Enrollments in Process',
            coremetricsParams: {
                elementId: 'QUICK LINKS ENROLLMENTS IN PROCESS',
                theCategory: 'EMPLOYERS:HOME PAGE'
            },
            filterData: {
                brand: ['*'],
                portal: 'employer',
                postPassword: true,
                entitlement: 'sessionData.entitlements.employees.edit && sessionData.entitlements.clientStatus.active'
            }
        });

        var idCardsLink = link.set('idCardsLink', {
            state: 'employee.find',
            label: 'ID Cards',
            coremetricsParams: {
                elementId: 'ID CARDS',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            desc: 'Print or order ID cards for your employees and their dependents. You can find an employee by entering their Last Name, Group Number, and/or Member ID.',
            filterData: {
                brand: ['*'],
                portal: 'employer',
                postPassword: true,
                entitlement: 'sessionData.entitlements.employees.view && sessionData.entitlements.clientStatus.active'
            }
        });

        var groupContractsLinkQL = link.set('groupContractsLinkQL', {
            'state': 'assistEmployees.groupContracts',
            'label': 'Group Contracts',
            coremetricsParams: {
                elementId: 'QUICK LINKS GROUP CONTRACTS',
                theCategory: 'EMPLOYERS:HOME PAGE'
            },
            'desc': 'Access group contracts here. You can search by Group Number.',
            'filterData': {
                'brand': mapUBKs([3004, 9001, 6002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 6005, 6006, 6007, 6008, 6009, 6011, 6012, 9015, 9016, 9017, 9018]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });

        var masterGroupContractsLinkQL = link.set('masterGroupContractsLinkQL', {
            'state': 'assistEmployees.groupContracts',
            'label': 'Master Group Contracts',
            coremetricsParams: {
                elementId: 'QUICK LINKS MASTER GROUP CONTRACTS',
                theCategory: 'EMPLOYERS:HOME PAGE'
            },
            'desc': 'Access master group contracts here. You can search by Group Number.',
            'filterData': {
                'brand': mapUBKs([6010]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });

        var benefitBookletsLinkQL = link.set('benefitBookletsLinkQL', {
            'state': 'assistEmployees.benefitBooklets',
            'label': 'Benefit Booklets',
            coremetricsParams: {
                elementId: 'QUICK LINKS BENEFIT BOOKLETS',
                theCategory: 'EMPLOYERS:HOME PAGE'
            },
            'desc': 'View in-depth information about the benefits for each of the plans your employer offers.  You can search by Group Number.',
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });

        // endregion

        var claimsLink = link.set('claimsLink', {
            state: 'employee.find',
            label: 'Claims',
            desc: 'Check the claim status, member liability, and date the claim was paid. You can find an employee by entering Last Name, Group Number, and/or Member ID.',
            coremetricsParams: {
                elementId: 'CLAIMS',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            filterData: {
                brand: mapUBKs([6002, 9001, 9011, 6005, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 6011, 6012, 9015, 9016, 9017, 9018]),
                portal: 'employer',
                postPassword: true,
                entitlement: 'sessionData.entitlements.employees.view && sessionData.entitlements.claims'
            }
        });

        var groupsLink = link.set("groupsLink", {
            state: 'groupList',
            url: "/employer/group-list",
            label: "Groups",
            filterData: {
                brand: ['*'],
                portal: "employer",
                postPassword: true,
                entitlement: "*"
            }
        });

        var clientLink = link.set("clientLink", {
            state: 'clientInfo.generalInfo',
            url: "/employer/client-info/general-info",
            label: "Client",
            filterData: {
                brand: ['*'],
                portal: "employer",
                postPassword: true,
                entitlement: "*"
            }
        });

        var groupsAndClients = link.set("groupsAndClients", {
            label: "Client/Groups",
            links: [
                clientLink,
                groupsLink
            ],
            options: {
                allowDropdown: true
            },
            filterData: {
                brand: ['*'],
                portal: "employer",
                postPassword: true,
                entitlement: "*"
            }
        });

        var assistEmployeesLink = link.set('assistEmployeesLink', {
            'state': 'assistEmployees',
            'url': '/employer/assist-employees',
            'label': 'Assist Employees',
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        // endregion

        // region LINKS on Assist Employees landing page ==============================================
        var groupContractsLink = link.set('groupContractsLink', {
            'state': 'assistEmployees.groupContracts',
            'label': 'Group Contracts',
            'desc': 'Access group contracts here. You can search by Group Number.',
            'filterData': {
                'brand': mapUBKs([3004, 9001, 6002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 6005, 6006, 6007, 6008, 6009, 6011, 9015, 9016, 9017, 9018]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });
        var groupContractsWYLink = link.set('groupContractsWYLink', {
            'state': 'assistEmployees.groupContracts',
            'label': 'Group Contracts',
            'desc': 'Access your Group Master Agreements.',
            'filterData': {
                'brand': mapUBKs([6012]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });
        var coveredDrugsFormularyList = link.set('coveredDrugsFormularyList', {
            'url': 'https://www.myprime.com/en/medicines.html#find-medicine',
            'newWindow': false,
            'label': 'Covered Drugs (Formulary) List',
            'desc': 'View preventive medication and other covered drugs under the plans selected for your employees. You can search by Group Number.',
            'filterData': {
                'brand': mapUBKs([6011]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });
        var PreventiveCareBenefitsListLink = link.set('PreventiveCareBenefitsListLink', {
            'url': 'https://www.bcbswy.com/wellness/preventive_care/',
            'newWindow': false,
            'label': 'Preventive Care Benefits List',
            'desc': 'View a list of preventive care benefits.',
            'filterData': {
                'brand': mapUBKs([6012]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });
        var masterGroupContractsLink = link.set('masterGroupContractsLink', {
            'state': 'assistEmployees.groupContracts',
            'label': 'Master Group Contracts',
            'desc': 'Access master group contracts here. You can search by Group Number.',
            'filterData': {
                'brand': mapUBKs([6010]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });
        var benefitBookletsLink = link.set('benefitBookletsLink', {
            'state': 'assistEmployees.benefitBooklets',
            'label': 'Benefit Booklets',
            'desc': 'View in-depth information about the benefits for each of the plans your employer offers.  You can search by Group Number.',
            'filterData': {
                'brand': mapUBKs([3004, 9001, 6002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 6005, 6006, 6007,6009, 6010, 9013, 6011, 9015, 6008, 9016, 9017, 9018]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });
        var benefitBookletsWYLink = link.set('benefitBookletsWYLink', {
            'state': 'assistEmployees.benefitBooklets',
            'label': 'Benefit Booklets',
            'desc': 'View in-depth information about the benefits for your plan.',
            'filterData': {
                'brand': mapUBKs([6012]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });
        var summaryOfBenefitsLink = link.set('summaryOfBenefitsLink', {
            'state': 'assistEmployees.summaryOfBenefits',
            'label': 'Summary of Benefits Coverage (SBC)',
            'desc': 'Compare plans using standard summaries for each of the plans your employer offers. You can search by Group Number',
            coremetricsParams: {
                elementId: 'SUMMARY OF BENEFIT BOOKLETS',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([3004, 9001, 6002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 6005, 6006, 6007, 6010, 9013, 6011, 9015, 9016, 9017, 9018]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });
        var summaryOfBenefitsWYLink = link.set('summaryOfBenefitsWYLink', {
            'state': 'assistEmployees.summaryOfBenefits',
            'label': 'Summary of Benefits Coverage (SBC)',
            'desc': 'See summary of plan benefits.',
            'filterData': {
                'brand': mapUBKs([6012]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.employees.view'
            }
        });

        var preventiveMedicationsLink = link.set('preventiveMedicationsLink', {
            'state': 'assistEmployees.preventiveMedications',
            'label': 'Preventive Medications List',
            'desc': 'View preventive medication lists for your employer. You can search by Group Number.',
            coremetricsParams: {
                elementId: 'PREVENTIVE MEDICATIONS',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([3004, 6002, 6005, 9001, 9003, 9004, 9005, 9006, 9007, 9008, 9011, 9015, 9016, 9017, 9018]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.clientStatus.active && sessionData.entitlements.employees.view'
            }
        });


        var findAProviderLink = link.set('findAProviderLink', {
            'url': "https://" + window.location.host + '/login/#/find-a-doctor' + '?from=employer',
            'newWindow': false,
            'label': 'Find a Provider',
            'desc': 'Find in-network hospitals, doctors, or other health care providers near you.',
            coremetricsParams: {
                elementId: 'FIND A PROVIDER',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([9001, 9002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 6002, 6005, 9015, 9016]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });

            //new Find a provider link for NENY
            var LatestfindAProviderNENYUrl = "https://highmark.sapphirecareselect.com/?ci=bsneny"; 
                
            var findAProviderNENYLink = link.set('findAProviderNENYLink', {
                'url': LatestfindAProviderNENYUrl,
                'newWindow': true,
                'label': 'Find a Provider',
                'desc': 'Find in-network hospitals, doctors, or other health care providers near you.',
                coremetricsParams: {
                    elementId: 'FIND A PROVIDER',
                    theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
                },
                'filterData': {
                    'brand': mapUBKs([9018]),
                    'portal': 'employer',
                    'postPassword': true,
                    'entitlement': '*'
                }
            });

            //new Find a provider link for WNY
            var LatestfindAProviderWNYUrl = "https://highmark.sapphirecareselect.com/?ci=bcbswny";     
            

            var findAProviderWNYLink = link.set('findAProviderWNYLink', {
                'url': LatestfindAProviderWNYUrl,
                'newWindow': true,
                'label': 'Find a Provider',
                'desc': 'Find in-network hospitals, doctors, or other health care providers near you.',
                coremetricsParams: {
                    elementId: 'FIND A PROVIDER',
                    theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
                },
                'filterData': {
                    'brand': mapUBKs([9017]),
                    'portal': 'employer',
                    'postPassword': true,
                    'entitlement': '*'
                }
            });





        // updating find a provider link to test with UAT environment..
        // configure with appConfig to turn on/off the latest url..
        var isTestEnvironment = /([dt]env([0-9]|[abcdet]))/.test(window.location.host);
        var LatestfindAProviderMNUrl = "https://" + window.location.host + '/find-a-doctor/home' + '?from=employer';
        if(sessionData && sessionData.appConfig && sessionData.appConfig.findAProvider && sessionData.appConfig.findAProvider.booleanValue) {
            if(isTestEnvironment){
                LatestfindAProviderMNUrl = 'https://uat.highmark.sapphirecareselect.com/?ci=bcbsmn';
            } else {
                LatestfindAProviderMNUrl = 'https://bcbsnd.sapphirecareselect.com/?ci=bcbsmn';
            }
        }
        var findAProviderMNLink = link.set('findAProviderMNLink', {
            'url': LatestfindAProviderMNUrl,
            'newWindow': true,
            'label': 'Find a Provider',
            'desc': 'Find in-network hospitals, doctors, or other health care providers near you.',
            coremetricsParams: {
                elementId: 'FIND A PROVIDER',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([6010]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        // updating find a provider link to test with UAT environment
        // configure with appConfig to turn on/off the latest url
        var latestFindAProviderNDUrl = "https://www.bcbsndportals.com/find-a-doctor/#/home";
        if(sessionData && sessionData.appConfig && sessionData.appConfig.findAProvider && sessionData.appConfig.findAProvider.booleanValue) {
            if(isTestEnvironment){
                latestFindAProviderNDUrl = 'https://uat.highmark.sapphirecareselect.com/?ci=bcbsnd';
            } else {
                latestFindAProviderNDUrl = 'https://bcbsnd.sapphirecareselect.com/?ci=bcbsnd';
            }
        }
        var findADoctorNDLink = link.set('findADoctorNDLink', {
            'url': latestFindAProviderNDUrl,
            "target" : "_self",
            'label': 'Find a Doctor',
            'desc': 'Find in-network hospitals, doctors, or other health care providers near you.',
            coremetricsParams: {
                elementId: 'FIND A DOCTOR',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([6011]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        // updating find a provider link to test with UAT environment
        // configure with appConfig to turn on/off the latest url
        var latestFindAProviderWYUrl = "https://www.yourwyoblue.com/find-a-doctor/#/home";
        if(sessionData && sessionData.appConfig && sessionData.appConfig.findAProvider && sessionData.appConfig.findAProvider.booleanValue) {
            if(isTestEnvironment){
                latestFindAProviderWYUrl = 'https://uat.highmark.sapphirecareselect.com/?ci=bcbswy';
            } else {
                latestFindAProviderWYUrl = 'https://bcbswy.sapphirecareselect.com/?ci=bcbswy';
            }
        }
        var findADoctorWYLink = link.set('findADoctorWYLink', {
            'url': latestFindAProviderWYUrl,
            "target" : "_self",
            'label': 'Find a Doctor',
            'desc': 'Find in-network hospitals, doctors, or other health care providers.',
            coremetricsParams: {
                elementId: 'FIND A DOCTOR',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([6012]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        var findADentistNDLink = link.set('findADentistNDLink', {
            'url': "https://nd.ourdentalcoverage.com/find-a-dentist/",
            'newWindow': false,
            'label': 'Find a Dentist',
            'desc': 'Find in-network dentists and orthodontists near you.',
            'type':'dental',
            coremetricsParams: {
                elementId: 'FIND A DENTIST',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([6011]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        var findADentistWYLink = link.set('findADentistWYLink', {
            'url': "https://wy.ourdentalcoverage.com/find-a-dentist/#/",
            'newWindow': false,
            'label': 'Find a Dentist',
            'desc': 'Search for a network dentist or dental specialist.',
            'type':'dental',
            coremetricsParams: {
                elementId: 'FIND A DENTIST',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([6012]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        var findAPharmacyWYLink = link.set('findAPharmacyWYLink', {
            'url': "https://www.myprime.com/v/BCBSWY/COMMERCIAL/WYSELECT/en/find-pharmacy.html",
            'newWindow': false,
            'label': 'Find a Pharmacy',
            'desc': 'Search for a network pharmacy for convenient services and access to more affordable prescription drugs.',
            coremetricsParams: {
                elementId: 'FIND A Pharmacy',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': mapUBKs([6012]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        var findAProviderLink_ibc = link.set('findAProviderLink_ibc', {
            'configure': function (clientNumber) {
                this.url = 'https://ibxpress.ibx.com/RedirectWeb/RedirectServlet?clientNumber=' + clientNumber + '&groupNumber=&brandCode=IBC&speciality';
            },
            'newWindow': true,
            'label': 'Find a Provider',
            'desc': 'Find in-network hospitals, doctors, or other health care providers near you.',
            'filterData': {
                'brand': mapUBKs([6008]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });

        var findAProviderLink_ahnj = link.set('findAProviderLink_ahnj', {
            'configure': function (clientNumber) {
                this.url = "https://amerihealthexpress.amerihealth.com/RedirectWeb/RedirectServlet?clientNumber=" + clientNumber + "&groupNumber=&brandCode=AHNJ&speciality=";
            },
            'newWindow': true,
            'label': 'Find a Provider',
            'desc': 'Find in-network hospitals, doctors, or other health care providers near you.',
            'filterData': {
                'brand': mapUBKs([6009]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        var visionProviderLink = link.set('visionProviderLink', {
            'state': 'assistEmployees.visionProvider',
            'label': 'Vision Provider Directory',
            'desc': 'Find in-network vision providers near you.',
            'type':'vision',
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.employerInfo.brandName!="6012" && sessionData.employerInfo.brandName!="6011"'
            }
        });
        var findanEyecareProviderNDLink = link.set('findanEyecareProviderNDLink', {
            'url': 'https://www.vsp.com/find-eye-doctors.html',
            'newWindow': false,
            'label': 'Find an Eye Care Provider',
            'desc': 'Search for an eye care provider including ophthalmologists, optometrists and retailers.',
            'type':'vision',
            'filterData': {
                'brand': mapUBKs([6011]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });
        var findanEyecareProviderWYLink = link.set("findanEyecareProviderWYLink", {
            url: "/login/#/vision-provider-search",
            "target":"_self",
            label: "Find an Eye Care Provider",
            'desc': 'Search for an eye care provider including ophthalmologists, optometrists and retailers.',
            'type':'vision',
            filterData: {
                brand: mapUBKs([6012]),
                portal: "employer",
                postPassword: true,
                entitlement: "*"
            }
        });
        var dentalProviderLink = link.set('dentalProviderLink', {
            configure: function (fn) {
                this.clickHandler = fn;
            },
            'label': 'Dental Provider Directory',
            'desc': 'Find in-network dentists near you.',
            'type':'dental',
            'filterData': {
                'brand': mapUBKs([3004, 9001, 9002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 9013, 6002, 6010, 9015, 9016, 9017, 9018]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });

        var changePCPLink = link.set('changePCPLink', {
            'state': 'employee.find',
            'label': 'Change PCP',
            'desc': 'Change the PCP for an employee and/or dependents. You can find an employee by entering Last Name, group Number, and/or Member ID',
            coremetricsParams: {
                elementId: 'CLICK CHANGE PCP',
                theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
            },
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.clientStatus.active && sessionData.entitlements.employees.edit && sessionData.employerInfo.brandName!="6012"'
            }
        });

        /*
         According to story 848550 to remove webmd links
         var hospitalQualityMeasuresLink = link.set('hospitalQualityMeasuresLink', {

         'url': '',
         'label': 'Hospital Quality Measures',
         'desc': 'Compare hospitals and procedures using WebMD\'s Hospital Advisor',
         coremetricsParams: {
         elementId: 'HOSPITAL QUALITY MEASURE',
         theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
         },
         'filterData': {
         'brand': mapUBKs([9001, 9002, 6002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 6005, 6010, 9015]),  // All but IBC n AHNJ
         'portal': 'employer',
         'postPassword': true,
         'entitlement': '*'
         }
         });

         */

        // BEGIN SPENDING ACCOUNTS LINKS ===============================================================

        // var acclarisSpendingAccountLink = link.set('acclarisSpendingAccountLink', {
        //     'url': 'https://' + window.location.host + '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/ACCLARISEMPLOYER',
        //     'label': 'Spending Account',
        //     'desc':'Manage spending accounts here.',
        //     'newWindow': true,
        //     'filterData': {
        //         'brand': ['*'],
        //         'portal': 'employer',
        //         'postPassword': true,
        //         'entitlement': 'sessionData.entitlements.clientQualifiers.spendingAccount && ' +
        //         '(sessionData.entitlements.spending.spendingAccountAccess || sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew || sessionData.entitlements.spending.noClaimsView) && ' +
        //         '!sessionData.entitlements.clientStatus.noAccess && ' +
        //         '!sessionData.entitlements.clientQualifiers.spendingAccountBlackedOut'

        //     }
        // });

        var alegeusSpendingAccountLink = link.set('alegeusSpendingAccountLink', {
            'url': 'https://' + window.location.host + '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/ALEGEUSEMPLOYER',
            'label': 'Spending Account',
            'desc': 'Manage spending accounts for employees.',
            'newWindow': true,
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.clientQualifiers.spendingAccount && ' +
                '(sessionData.entitlements.spending.spendingAccountAccess || sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew || sessionData.entitlements.spending.noClaimsView) && ' +
                '!sessionData.entitlements.clientStatus.noAccess && ' +
                '!sessionData.entitlements.clientQualifiers.spendingAccountBlackedOut'
            }
        });

        var spendingAccountReportGuideLink_wpa = link.set('spendingAccountReportGuideLink', {
            'url': '/redesign/pdf/105608_Spending_Accnt_Rep_Guide_BCBS.pdf',
            'label': 'Spending Account Report Guide',
            'desc': 'Use this guide to understand the spending account report that provide data and insight into your employer\'s account activity.',
            'filterData': {
                'brand': mapUBKs([9001, 9002, 9017, 9018]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew ' +
                '|| sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });
        var spendingAccountReportGuideLink_wv = link.set('spendingAccountReportGuideLink', {
            'url': '/redesign/pdf/105608_Spending_Accnt_Rep_Guide_BCBSWV.pdf',
            'label': 'Spending Account Report Guide',
            'desc': 'Use this guide to understand the spending account report that provide data and insight into your employer\'s account activity.',
            'filterData': {
                'brand': mapUBKs([9008, 9009]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '( sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew ' +
                '|| sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });
        var spendingAccountReportGuideLink_mbh = link.set('spendingAccountReportGuideLink', {
            'url': '/redesign/pdf/105608_Spending_Accnt_Rep_Guide_MBH.pdf',
            'label': 'Spending Account Report Guide',
            'desc': 'Use this guide to understand the spending account report that provide data and insight into your employer\'s account activity.',
            'filterData': {
                'brand': mapUBKs([9005, 9006, 9007, 9015, 9016]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew ' +
                '|| sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });
        var spendingAccountReportGuideLink_de = link.set('spendingAccountReportGuideLink', {
            'url': '/redesign/pdf/105608_Spending_Accnt_Rep_Guide_BCBSDE.pdf',
            'label': 'Spending Account Report Guide',
            'desc': 'Use this guide to understand the spending account report that provide data and insight into your employer\'s account activity.',
            'filterData': {
                'brand': mapUBKs([9011]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew ' +
                '|| sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });
        var spendingAccountReportGuideLink_cpa = link.set('spendingAccountReportGuideLink', {
            'url': '/redesign/pdf/105608_Spending_Accnt_Rep_Guide_BS.pdf',
            'label': 'Spending Account Report Guide',
            'desc': 'Use this guide to understand the spending account report that provide data and insight into your employer\'s account activity.',
            'filterData': {
                'brand': mapUBKs([6002]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew ' +
                '|| sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });
        var spendingAccountReportGuideLink_mbhibc = link.set('spendingAccountReportGuideLink', {
            'url': '/redesign/pdf/CS200499_Spending_Account_Reporting_Guide.pdf',
            'label': 'Spending Account Report Guide',
            'desc': 'Use this guide to understand the spending account report that provide data and insight into your employer\'s account activity.',
            'filterData': {
                'brand': mapUBKs([9003]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew ' +
                '|| sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });
        var spendingAccountReportGuideLink_mbhMn = link.set('spendingAccountReportGuideLink', {
            'url': '/redesign/pdf/105608_Spending_Accnt_Rep_Guide_MN.pdf',
            'label': 'Spending Account Report Guide',
            'desc': 'Use this guide to understand the spending account report that provide data and insight into your employer\'s account activity.',
            'filterData': {
                'brand': mapUBKs([9004]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew ' +
                '|| sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });

        var manageSpendingAccountElectionsLink = link.set('manageSpendingAccountElectionsLink', {
            'state': 'employee.find',
            'label': 'Manage Current Year Spending Account Elections',
            'desc': 'Manage spending account elections for employees',
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.spendingAccountAccess || sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew || ' +
                'sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });

        var eligibleExpensesLink = link.set('eligibleExpensesLink', {
            'url': 'http://hcet.ebia.com/hmrk',
            'label': 'Eligible Expenses',
            'desc': 'Check this list of eligible spending account expenses.',
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.spendingAccountAccess || sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew ' +
                ' || sessionData.entitlements.spending.noClaimsView) && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });

        var onlineAnswersAndHowTosLink = link.set('onlineAnswersAndHowTosLink', {
            'url': 'https://www.highmarkspendingaccounts.com',
            'label': 'Online Answers and How-Tos',
            'desc': 'Learn the basics and get started with Health Savings Account, Flexible Spending Account, or Health Reimbursement Account.',
            'filterData': {
                'brand': mapUBKs([6002, 9001, 9002, 9011, 9012, 9017, 9018]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.spendingAccountAccess || sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew || sessionData.entitlements.spending.noClaimsView)' +
                ' && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });
        var onlineAnswersAndHowTosLink_mbh = link.set('onlineAnswersAndHowTosLink', {
            'url': 'http://www.mbhspendingaccounts.com',
            'label': 'Online Answers and How-Tos',
            'desc': 'Learn the basics and get started with Health Savings Account, Flexible Spending Account, or Health Reimbursement Account.',
            'filterData': {
                'brand': mapUBKs([6005, 9003, 9004, 9005, 9006, 9007, 9008, 9015, 9009, 9010, 9016]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '(sessionData.entitlements.spending.spendingAccountAccess || sessionData.entitlements.spending.claimsView || sessionData.entitlements.spending.claimsViewNew || sessionData.entitlements.spending.noClaimsView)' +
                ' && (!sessionData.entitlements.clientStatus.noAccess)' +
                ' && sessionData.entitlements.clientQualifiers.spendingAccount'
            }
        });

        // BEGIN EDUCATIONAL TOOLS LINKS ================================================================
        // Removed consumer health tools for all brands as per story FEAT1166444
        // As all filter set to highmark region, I have removed Second Opinion Health Education Series link from assist employee tab
        // var secondOpinionHealthEducationLink = link.set('secondOpinionHealthEducationLink', {
        //     'url': 'https://www.bcbs.com/why-bcbs/secondopinion',
        //     'label': 'Second Opinion Health Education Series',
        //     'desc': 'Watch doctors manage real-life cases.',
        //     coremetricsParams: {
        //         elementId: 'SECOND OPINION HEALTH',
        //         theCategory: 'EMPLOYERS:ASSIST EMPLOYEES'
        //     },
        //     'filterData': {
        //         'brand': mapUBKs([6002, 9001, 9002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 9015, 9016, 9017, 9018]),
        //         'portal': 'employer',
        //         'postPassword': true,
        //         'entitlement': '*'
        //     }
        // });

        var memberResourceGuideLink = link.set('memberResourceGuideLink', {
            'url': '/pdffiles/WellnessGuidelines_IBC.pdf',
            'label': 'Wellness Guidelines',
            'desc': 'Share this with employees! It contains preventive care recommendations, topics for provider visits, and a place to track health care info.',
            'filterData': {
                'brand': mapUBKs([6008, 6009]),
                'portal': 'employer',
                'postPassword': true,
                'entitlement': '*'
            }
        });

        var billingLink = link.set('billingLink', {
            'url': '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/EBILL',
            'newWindow': true,
            'label': 'Billing',
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.billing && !sessionData.entitlements.clientStatus.noAccess'
            }
        });

        var reportsLink = link.set('reportsLink', {
            'state': 'reports',
            'url': '/employer/reports',
            'label': 'Reports',
            'filterData': {
                'brand': ['*'],
                'portal': 'employer',
                'postPassword': true,
                'entitlement': 'sessionData.entitlements.reports.enrollment || sessionData.entitlements.reports.medeAnalytics || sessionData.entitlements.reports.atHand || sessionData.entitlements.reports.CensusReports || sessionData.entitlements.reports.WellnessReports'
            }
        });

        var resourcesLink = link.set("resourcesLink", {
            "state": "resources",
            "url": "/employer/resources",
            "label": "Resources",
            "filterData": {
                "brand": ['*'],
                "portal": "employer",
                "postPassword": true,
                "entitlement": "*"
            },
            "links": [
                link.set("Request ID Card", {
                    "state": "resources.requestIdCard",
                    "label": "Request ID Card",
                    "filterData": {"portal": "employer"}
                })
            ]
        });
        // endregion
        var enrollmentTutorialLink = link.set('enrollmentTutorialLink', {
            url: '/pdffiles/employer-portal-training-guide.pdf',
            label: 'Enrollment Tutorial',
            desc: 'Find out everything you need to get started by taking this quick, helpful tutorial.',
            coremetricsParams: {
                elementId: 'ENROLLMENT TUTORIAL',
                theCategory: 'EMPLOYERS:ENROLLMENT'
            },
            filterData: {
                brand: mapUBKs([9001, 9002, 9003, 9004, 9005, 9006, 9007, 9008, 9009, 9011, 6002, 6005, 6010, 9015, 9016, 9017, 9018]),
                portal: 'employer',
                postPassword: true,
                entitlement: '*'
            }
        });
        var enrollmentTutorialLink_IBC = link.set('enrollmentTutorialLink_IBC', {
            url: '/pdffiles/employer-portal-training-guide_IBC.pdf',
            label: 'Enrollment Tutorial',
            desc: 'Find out everything you need to get started by taking this quick, helpful tutorial.',
            coremetricsParams: {
                elementId: 'ENROLLMENT TUTORIAL',
                theCategory: 'EMPLOYERS:ENROLLMENT'
            },
            filterData: {
                brand: mapUBKs([6008]),
                portal: 'employer',
                postPassword: true,
                entitlement: '*'
            }
        });
        var enrollmentTutorialLink_AHNJ = link.set('enrollmentTutorialLink_AHNJ', {
            url: '/pdffiles/employer-portal-training-guide_AHNJ.pdf',
            label: 'Enrollment Tutorial',
            desc: 'Find out everything you need to get started by taking this quick, helpful tutorial.',
            coremetricsParams: {
                elementId: 'ENROLLMENT TUTORIAL',
                theCategory: 'EMPLOYERS:ENROLLMENT'
            },
            filterData: {
                brand: mapUBKs([6009]),
                portal: 'employer',
                postPassword: true,
                entitlement: '*'
            }
        });

        var enrollmentTutorialLink_Wyoming = link.set('enrollmentTutorialLink_Wyoming', {
            url: '/redesign/pdf/ep_forms/enrollment_tutorial.pdf',
            label: 'Enrollment Tutorial',
            desc: 'Find out everything you need to get started by taking this quick, helpful tutorial.',
            coremetricsParams: {
                elementId: 'ENROLLMENT TUTORIAL',
                theCategory: 'EMPLOYERS:ENROLLMENT'
            },
            filterData: {
                brand: mapUBKs([6012]),
                portal: 'employer',
                postPassword: true,
                entitlement: '*'
            }
        });

        var enrollmentTutorialLink_NorthDakota = link.set('enrollmentTutorialLink_NorthDakota', {
            url: '/redesign/pdf/ep_forms/employer-portal-training-guide%20(1).pdf',
            label: 'Enrollment Tutorial',
            desc: 'Find out everything you need to get started by taking this quick, helpful tutorial.',
            coremetricsParams: {
                elementId: 'ENROLLMENT TUTORIAL',
                theCategory: 'EMPLOYERS:ENROLLMENT'
            },
            filterData: {
                brand: mapUBKs([6011]),
                portal: 'employer',
                postPassword: true,
                entitlement: '*'
            }
        });

        // region LINKS, Header, Grey Nav, and User ============================================
        /*
         * Grey nav links
         */
        var emailGreyLink = link.set('emailGreyLink', {
            href: 'https://securemail-highmark.com/s/login?b=hmrksrvc',
            newWindow: true,
            label: 'e',
            icon: true,
            filterData: {
                postPassword: true,
                portal: 'employer',
                brand: mapUBKs([3001, 3003, 3004, 6001, 6002, 6003, 6004, 6005, 6006, 6007, 6010, 9001, 9002, 9004, 9005, 9006, 9007, 9008, 9009, 9010, 9011, 9012, 9013, 9014, 6011, 9015, 9016, 9017, 9018])
            }
        });

        /*
         * Header Logo and Title
         */

        var preLoginLogo = link.set("preLoginLogo", {
            "state": "login",
            "filterData": {
                "postPassword": false,
                "portal": "employer"
            }
        });

        var employerLogo = link.set("clientLogo", {
            "state": "home",
            "filterData": {
                "postPassword": true,
                "portal": "employer"
            }
        });

        var title = link.set("title", {
            "type": "title",
            "title": "Employer Portal",
            "filterData": {
                "postPassword": true,
                "portal": "employer"
            }
        });

        /*
         * User Links
         */
        var loginLink = link.set("loginLink", {
            "display": true,
            "filterData": {
                "postPassword": true,
                "portal": "employer"
            }
        });

        var profileUser = link.set("profileUser", {
            "state": "profile",
            "label": "Profile",
            "filterData": {
                "brand": ['*'],
                "postPassword": true,
                "admin": true,
                "portal": "employer"
            }
        });
        var clientSelection = link.set("clientSelection", {
            "state": "clientselection",
            "label": "Switch Client",
            "filterData": {
                "brand": mapUBKs([6010, 6011,6001,9001,9011,9009,9017,9018,6002]),
                "postPassword": true,
                "admin": true,
                "portal": "employer",
                "entitlement": 	"sessionData.isClientselection"
            }
        });
        // endregion

        // region Footer Items - Setup Questions, Customer Service, Membership Questions ===============================

        var topFooterBlockOneWpaEtc = link.set("topFooterBlockOne", {
            "title": "Setup/Login Questions",
            "links": [
                link.set("setupText", {
                    "text": "877-298-3918\n" +
                    "For issues with user setup, etc.",
                    "filterData": {
                        "portal": "employer"
                    }
                })
                //link.set("setupTextTwo", {
                //	"text": "For issues with user setup, etc.",
                //	"filterData": {"portal": "employer"}
                //})
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6001, 9001, 9002, 6002, 6004, 9011, 6005, 9003, 9004, 9005, 9006, 9007, 9008, 9015, 9016])
            }
        });
        var topFooterBlockOneWYM = link.set("topFooterBlockOne", {
            "title": "Setup/Login Questions",
            "links": [
                link.set("setupText", {
                    "text": "Trouble with your user account?<br>" +
                    "<span><a href='https://www.bcbswy.com/insurance/' target='_blank'>" +
                    "Contact your local BCBSWY Agent.</a></span>",
                    "filterData": {
                        "portal": "employer"
                    }
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var topFooterBlockOneMn = link.set("topFooterBlockOne", {
            "title": "Setup/Login Questions",
            "links": [
                link.set("setupText", {
                    "text": "1-866-582-1166<br>" +
                    "For issues with user setup, etc.",
                    "filterData": {
                        "portal": "employer"
                    }
                })
                //link.set("setupTextTwo", {
                //	"text": "For issues with user setup, etc.",
                //	"filterData": {"portal": "employer"}
                //})
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9013, 6010])
            }
        });
        var topFooterBlockTwoIbc = link.set("topFooterBlockTwo", {
            "title": "Billing Inquiries",
            "links": [
                link.set("csText", {
                    "text": "215-567-3357 (Philadelphia Area)",
                    "filterData": {"portal": "employer"}
                }),
                link.set("csTextTwo", {
                    "text": "1-800-444-6301 (Outside Philadelphia)",
                    "filterData": {"portal": "employer"}
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6008])
            }
        });
        var topFooterBlockTwoWpaEtc = link.set("topFooterBlockTwo", {
            "title": "Customer Service",
            "links": [
                link.set("csText", {
                    "text": "866-306-1059<br>" +
                    "For questions regarding site navigation and functionality",
                    "filterData": {"portal": "employer"}
                })
                //link.set("csTextTwo", {
                //	"text": "For questions regarding site navigation and functionality",
                //	"filterData": {"portal": "employer"}
                //})
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6001, 9001, 9002, 6002, 6004, 9011, 6005, 9003, 9004, 9005, 9006, 9007, 9008, 9015, 9016])
            }
        });
        var topFooterBlockTwoND = link.set("topFooterBlockTwo", {
            "title": "Member Service",
            "links": [
                link.set("csText", {
                    "text": "1-844-363-8457<br>" +
                    "For member questions regarding<br>"+
                    "benefits and coverage.",
                    "filterData": {"portal": "employer"}
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6011])
            }
        });
        var topFooterBlockTwoWYM = link.set("topFooterBlockTwo", {
            "title": "Member Service",
            "links": [
                link.set("csText", {
                    "text": "Questions?<br>" +
                    "We’re here to help.<br>"+
                    "Monday-Friday 8 a.m. – 5 p.m.<br>" +
                    "800-442-2376 <br>" +
                    "TTY: 711",
                    "filterData": {"portal": "employer"}
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var topFooterBlockTwoMn = link.set("topFooterBlockTwo", {
            "title": "Customer Service",
            "links": [
                link.set("csText", {
                    "text": "1-877-293-7035<br>" +
                    "For questions regarding site navigation<br>"+
                    "and functionality",
                    "filterData": {"portal": "employer"}
                })
                //link.set("csTextTwo", {
                //	"text": "For questions regarding site navigation and functionality",
                //	"filterData": {"portal": "employer"}
                //})
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6010, 9013])
            }
        });
        var topFooterBlockOneAhnj = link.set("topFooterBlockOne", {
            "title": "Setup/Login Questions and Customer Service",
            "links": [
                link.set("setupText", {
                    "text": "877-219-5453",
                    "filterData": {
                        "portal": "employer"
                    }
                }),
                link.set("setupTextTwo", {
                    "text": "For issues with user setup, membership questions and questions regarding site navigation and functionality.",
                    "filterData": {"portal": "employer"}
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6009])
            }
        });
        var topFooterBlockOneIbc = link.set("topFooterBlockOneIbc", {
            "title": "Setup/Login Questions and Customer Service",
            "links": [
                link.set("setupText", {
                    "text": "215-587-0360",
                    "filterData": {
                        "portal": "employer"
                    }
                }),
                link.set("setupTextTwo", {
                    "text": "For issues with user setup, membership questions and questions regarding site navigation and functionality.",
                    "filterData": {"portal": "employer"}
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6008])
            }
        });

        var topFooterBlockThreeWpaEtc = link.set("topFooterBlockThree", {
            "title": "Membership Questions",
            "links": [
                link.set("setupText", {
                    "text": "Please call your membership auditor for questions regarding membership information",
                    "filterData": {"portal": "employer"}
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6001, 9001, 9002, 6002, 6004, 9011, 6005, 9003, 9004, 9005, 9006, 9007, 9008, 9015, 9016])
            }
        });
        var topFooterBlockThreeND = link.set("topFooterBlockThree", {
            "title": "Customer Service",
            "links": [
                link.set("setupText", {
                    "text": "Please contact your BCBSND Representative for questions regarding your employer group account.",
                    "filterData": {"portal": "employer"}
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6011])
            }
        });
        var topFooterBlockThreeWYM = link.set("topFooterBlockThree", {
            "title": "Membership Questions",
            "links": [
                link.set("setupText", {
                    "text": "Questions about your membership information?<br>"+
                    "<span><a href='https://www.bcbswy.com/insurance/' target='_blank'>" +
                    "Contact your local BCBSWY Agent</a></span>",
                    "filterData": {"portal": "employer"}
                })
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var topFooterBlockThreeMn = link.set("topFooterBlockThree", {
            "title": "Billing Questions",
            "links": [
                link.set("setupText", {
                    "text": "Small Group: 1-800-711-9864 <br>" +
                    "Large Group Fully insured: 1-800-711-9864<br>"+
                    "Large Group Self-insured: Contact your Billing Analyst",
                    "filterData": {"portal": "employer"}
                })
                //link.set("setupText", {
                //	"text": "Large Group Fully insured: 1-800-711-9864",
                //	"filterData": {"portal": "employer"}
                //}),
                //link.set("setupText", {
                //	"text": "Large Group Self-insured: Contact your Billing Analyst",
                //	"filterData": {"portal": "employer"}
                //})
            ],
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9013, 6010])
            }
        });
        // AHNJ does not get this item

        // var footerTabsTwo = navigation.set("footerTabsTwo");
        // footerTabsTwo.linkFilters.push("portal", "brand");
        // footerTabsTwo.links.push(topFooterBlockOneWpaEtc, topFooterBlockTwoND,topFooterBlockOneWYM, topFooterBlockOneMn, topFooterBlockOneAhnj, topFooterBlockOneIbc,
        // 	topFooterBlockTwoWpaEtc, topFooterBlockTwoWYM, topFooterBlockTwoIbc, topFooterBlockTwoMn,
        // 	topFooterBlockThreeWpaEtc, topFooterBlockThreeND, topFooterBlockThreeWYM, topFooterBlockThreeMn ) ;
        var footerTabsTwo = navigation.get("footerTabsTwo") || navigation.set("footerTabsTwo");
        if(footerTabsTwo.length){
            footerTabsTwo[0].linkFilters.splice(0,footerTabsTwo[0].linkFilters.length);
            footerTabsTwo[0].linkFilters.push("portal", "brand");
            footerTabsTwo[0].links.splice(0,footerTabsTwo[0].links.length);
            footerTabsTwo[0].links.push(topFooterBlockOneWpaEtc, topFooterBlockTwoND,topFooterBlockOneWYM, topFooterBlockOneMn, topFooterBlockOneAhnj, topFooterBlockOneIbc,
                                        topFooterBlockTwoWpaEtc, topFooterBlockTwoWYM, topFooterBlockTwoIbc, topFooterBlockTwoMn,
                                        topFooterBlockThreeWpaEtc, topFooterBlockThreeND, topFooterBlockThreeWYM, topFooterBlockThreeMn);
        }
        else {
            footerTabsTwo.linkFilters.splice(0,footerTabsTwo.linkFilters.length);
            footerTabsTwo.linkFilters.push("portal", "brand");
            footerTabsTwo.links.splice(0,footerTabsTwo.links.length);
            footerTabsTwo.links.push(topFooterBlockOneWpaEtc, topFooterBlockTwoND,topFooterBlockOneWYM, topFooterBlockOneMn, topFooterBlockOneAhnj, topFooterBlockOneIbc,
                                     topFooterBlockTwoWpaEtc, topFooterBlockTwoWYM, topFooterBlockTwoIbc, topFooterBlockTwoMn,
                                     topFooterBlockThreeWpaEtc, topFooterBlockThreeND, topFooterBlockThreeWYM, topFooterBlockThreeMn);
        }


        // endregion

        // region Footer Items - Middle Items - About Company and Privacy Policy ======================
        var middleItemOneWpa = link.set("middleItemOneWpa", {
            "title": "About Company",
            "url": "https://www.highmark.com/hmk2/about/vision/index.shtml",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9001, 9002])
            }
        });
        var middleItemOneNeny = link.set("middleItemOneNeny", {
            "title": "About Company",
            "url": "https://www.bsneny.com/content/neny/about.html",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9018])
            }
        });
        var middleItemOneWny = link.set("middleItemOneWny", {
            "title": "About Company",
            "url": "https://www.bcbswny.com/content/wny/about.html",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9017])
            }
        });
        var middleItemOneND = link.set("middleItemOneND", {
            "title": "About Company",
            "url": "https://www.bcbsnd.com/about/company",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6011])
            }
        });
        var middleItemOneWYM = link.set("middleItemOneWYM", {
            "title": "About Company",
            "url": "https://www.bcbswy.com/company_info/",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var middleItemOneCre = link.set("middleItemOneCre", {
            "title": "About Company",
            "url": "https://www.highmark.com/hmk2/about/vision/index.shtml",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6002])
            }
        });
        var middleItemOneDe = link.set("middleItemOneDe", {
            "title": "About Company",
            "url": "https://www.highmark.com/hmk2/about/vision/index.shtml",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9011])
            }
        });
        var middleItemOneMn = link.set("middleItemOneMn", {
            "title": "About Company",
            "url": "https://www.bluecrossmn.com/healthy/public/personal/home/about-us",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9013, 6010])
            }
        });
        // PRIVACY POLICY - FOOTER ITEM ================================================
        var middleItemTwoWpa = link.set("middleItemTwoWpa", {
            "title": "Privacy Policy",
            "url": "https://www.highmark.com/hmk2/privacy.shtml",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9001, 9002])
            }
        });
        var middleItemTwoNeny = link.set("middleItemTwoNeny", {
            "title": "Privacy Policy",
            "url": "https://www.bsneny.com/content/neny/privacy-practices.html",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9018])
            }
        });
        var middleItemTwoWny = link.set("middleItemTwoWny", {
            "title": "Privacy Policy",
            "url": "https://www.bcbswny.com/content/wny/privacy-practices.html",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9017])
            }
        });
        var middleItemTwoND = link.set("middleItemTwoND", {
            "title": "Privacy Policy",
            "url": "https://www.bcbsnd.com/privacy/policy",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6011])
            }
        });
        var middleItemTwoWYM = link.set("middleItemTwoWYM", {
            "title": "Privacy Policy",
            "url": "https://www.bcbswy.com/privacy/",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var middleItemTwoCre = link.set("middleItemTwoCre", {
            "title": "Privacy Policy",
            "url": "https://www.highmark.com/hmk2/privacy.shtml",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6002])
            }
        });
        var middleItemTwoDe = link.set("middleItemTwoDe", {
            "title": "Privacy Policy",
            "url": "http://www.athighmark.com/privacy/de/index.shtml",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9011])
            }
        });
        var middleItemTwoWv = link.set("middleItemTwoWv", {
            "title": "Privacy Policy",
            "url": "https://www.mybenefitshome.com/pdffiles/MSPrivacyStmnt.pdf",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9009])
            }
        });
        var middleItemTwoFl = link.set("middleItemTwoFl", {
            "title": "Privacy Policy",
            "url": "https://www.mybenefitshome.com/pdffiles/FLPrivacyPolicyStmnt1023.pdf",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9005])
            }
        });
        var middleItemTwoAz = link.set("middleItemTwoAz", {
            "title": "Privacy Policy",
            "url": "https://www.mybenefitshome.com/pdffiles/arizona.privacy.pdf",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9007])
            }
        });
        var middleItemTwoMnMbh = link.set("middleItemTwoMnMbh", {
            "title": "Privacy Policy",
            "url": "https://www.mybenefitshome.com/pdffiles/MNOnline%20Privacy%20Policy.pdf",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9004])
            }
        });
        var middleItemTwoIbcMbh = link.set("middleItemTwoIbcMbh", {
            "title": "Privacy Policy",
            "url": "https://www.mybenefitshome.com/pdffiles/IBC.privacy.pdf",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9003])
            }
        });
        var middleItemTwoMn = link.set("middleItemTwoMn", {
            "title": "Privacy And Legal",
            "url": "https://www.bluecrossmn.com/healthy/public/personal/home/footer/legal-privacy",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9013, 6010])
            }
        });
        var middleItemTwoIbc = link.set("middleItemTwoIbc", {
            "title": "Privacy Policy",
            "url": "https://www.ibx.com/privacy/index.html",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6008])
            }
        });
        var middleItemTwoAhnj = link.set("middleItemTwoAhnj", {
            "title": "Privacy Policy",
            "url": "https://www.amerihealth.com/htdocs/privacy/login_privacy_popup.html",
            "target": "_blank",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6009])
            }
        });

        // var footerTabsThree = navigation.set("footerTabsThree");
        // footerTabsThree.linkFilters.push("portal", "brand");
        // footerTabsThree.links.push(
        // 	middleItemOneWpa, middleItemOneND, middleItemOneWYM, middleItemOneCre, middleItemOneDe, middleItemOneMn,
        // 	middleItemTwoWpa, middleItemTwoND, middleItemTwoWYM, middleItemTwoCre, middleItemTwoDe, middleItemTwoWv, middleItemTwoFl, middleItemTwoAz,
        // 	middleItemTwoMnMbh, middleItemTwoIbcMbh, middleItemTwoMn, middleItemTwoIbc, middleItemTwoAhnj
        // );
        var footerTabsThree = navigation.get("footerTabsThree") || navigation.set("footerTabsThree");
        if(footerTabsThree.length){
            footerTabsThree[0].linkFilters.splice(0,footerTabsThree[0].linkFilters.length);
            footerTabsThree[0].linkFilters.push("portal", "brand");
            footerTabsThree[0].links.splice(0,footerTabsThree[0].links.length);
            footerTabsThree[0].links.push(middleItemOneWpa, middleItemOneND, middleItemOneWYM, middleItemOneCre, middleItemOneDe, middleItemOneMn,
                                          middleItemTwoWpa, middleItemTwoND, middleItemTwoWYM, middleItemTwoCre, middleItemTwoDe, middleItemTwoWv, middleItemTwoFl, middleItemTwoAz,
                                          middleItemTwoMnMbh, middleItemTwoIbcMbh, middleItemTwoMn, middleItemTwoIbc, middleItemTwoAhnj, middleItemOneWny,middleItemOneNeny, middleItemTwoNeny, middleItemTwoWny);
        }
        else {
            footerTabsThree.linkFilters.splice(0,footerTabsThree.linkFilters.length);
            footerTabsThree.linkFilters.push("portal", "brand");
            footerTabsThree.links.splice(0,footerTabsThree.links.length);
            footerTabsThree.links.push(middleItemOneWpa, middleItemOneND, middleItemOneWYM, middleItemOneCre, middleItemOneDe, middleItemOneMn,
                                       middleItemTwoWpa, middleItemTwoND, middleItemTwoWYM, middleItemTwoCre, middleItemTwoDe, middleItemTwoWv, middleItemTwoFl, middleItemTwoAz,
                                       middleItemTwoMnMbh, middleItemTwoIbcMbh, middleItemTwoMn, middleItemTwoIbc, middleItemTwoAhnj, middleItemOneWny,middleItemOneNeny, middleItemTwoNeny, middleItemTwoWny);
        }

        // endregion

        // region Footer Items - Full width text lines at bottom of footer =======================================

        // WPA, CRE, DE ------------------------------------------------------------------------------
        var footerTextOneWpaEtc = link.set("footerTextOne", {
            "text": "<p>This site works best if viewed with the latest version of Internet Explorer, Firefox, Chrome, or Safari browsers. For the best performance and security, always keep your web browser up-to-date.</p>",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6001, 9001, 6002, 6004, 9011, 6011, 9017, 9018])
            }
        });
        var footerTextTwoWpaEtc = link.set("footerTextTwo", {
            "text": 'The information contained on this website regarding the Patient Protection and Affordable Care Act of 2010 (&quot;PPACA&quot;), as amended, and/or any other law, does not constitute legal or tax advice and is subject to change based upon the issuance of new guidance and/or change in laws.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6001, 9001, 6002, 6004, 9011, 6011, 9017, 9018])
            }
        });
        var footerTextThreeWpaEtc = link.set("footerTextThree", {
            "text": 'The information provided is intended to provide general information only and does not attempt to give you advice that relates to your specific circumstances. State laws and regulations governing health insurance and health plans may vary from state to state. Further, any information regarding any health plan will be subject to the terms of its particular health plan benefit agreement and some health plans may not be available in every region or state.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6001, 9001, 6002, 6004, 9011, 6011, 9017, 9018])
            }
        });
        var footerTextFourND = link.set("footerTextFour", {
            "text": 'Blue Cross Blue Shield of North Dakota is an independent licensee of the Blue Cross and Blue Shield Association, serving residents and businesses in North Dakota.'+
            '© 2018 Blue Cross Blue Shield of North Dakota. All rights reserved.\n'+
            '<p><span><a href="https://www.bcbsnd.com/documents/10181/6527267/Language_and_Disability_Access_Assistance/f6538f54-3702-4ac6-9d46-9a8b8f981df3">' +
            'Non-Discrimination Notice</a></span></p>',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6011])
            }
        });
        //---WY----
        var footerTextOneWpaEtcWY = link.set("footerTextOne", {
            "text": "Blue Cross® Blue Shield® of Wyoming is an independent licensee of the Blue Cross and Blue Shield Association " +
            "Serving residents and businesses in Wyoming "+
            "® Registered marks of the Blue Cross and Blue Shield Association.",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var footerTextTwoWpaEtcWY = link.set("footerTextTwo", {
            "text": "<p>This site works best if viewed with the latest version of Internet Explorer, Firefox, Chrome, or Safari browsers. For the best performance and security, always keep your web browser up-to-date.</p>" ,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var footerTextThreeWpaEtcWY = link.set("footerTextThree", {
            "text": 'The information contained on this website regarding the Patient Protection and Affordable Care Act of 2010 (&quot;PPACA&quot;), as amended, and/or any other law, does not constitute legal or tax advice and is subject to change based upon the issuance of new guidance and/or change in laws.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var footerTextFourWpaEtcWY = link.set("footerTextFour", {
            "text": 'The information provided is intended to provide general information only and does not attempt to give you advice that relates to your specific circumstances. State laws and regulations governing health insurance and health plans may vary from state to state. Further, any information regarding any health plan will be subject to the terms of its particular health plan benefit agreement and some health plans may not be available in every region or state.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        // WV ----------------------------------------------------------------------------------------------------

        var footerTextOneWvNebAzFl = link.set("footerTextTwo", {
            "text": '<p>&reg; Highmark is a registered mark of Highmark Inc. </p>' +
            '<p>&copy; 2017 Highmark Inc., All Rights Reserved</p>' +
            '<p>&reg; Blue Cross, Blue Shield and the Cross and Shield symbols are registered service marks of the Blue Cross and Blue Shield Association, an association of independent Blue Cross and Blue Shield companies.</p>',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6003, 9009, 9008, 9006, 9007, 9005, 9015, 9016])
            }
        });
        var footerTextTwoWv = link.set("footerTextThree", {
            "text": '<p>Highmark Blue Cross Blue Shield West Virginia is an Independent Licensee of the Blue Cross and Blue Shield Association</p>.' +
            '<p>Highmark Blue Cross Blue Shield West Virginia serves the entire state of West Virginia plus Washington County, Ohio.</p>',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6003, 9009])
            }
        });
        var footerTextTwoNeb = link.set("footerTextThree", {
            "text": 'Blue Cross and Blue Shield of Nebraska is an independent licensee of the Blue Cross and Blue Shield Association.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9006])
            }
        });
        var footerTextTwoAz = link.set("footerTextThree", {
            "text": 'Blue Cross Blue Shield of Arizona is an independent licensee of the Blue Cross and Blue Shield Association.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9007])
            }
        });
        var footerTextTwoFl = link.set("footerTextThree", {
            "text": 'Blue Cross Blue Shield of Florida is an independent licensee of the Blue Cross and Blue Shield Association.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9005])
            }
        });
        var footerTextTwoIdh = link.set("footerTextThree", {
            "text": 'Blue Cross and Blue Shield of Idaho is an independent licensee of the Blue Cross and Blue Shield Association.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9015])
            }
        });
        var footerTextTwoLa = link.set("footerTextThree", {
            "text": 'Blue Cross and Blue Shield of Louisiana, Inc., is an independent licensee of the Blue Cross and Blue Shield Association and is licensed to use the Blue Cross and Blue Shield names and Blue Cross and Blue Shield marks in the state of Louisiana.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9016])
            }
        });

        // Download Firefox ... WV, AZ, Neb, FL,
        var footerTextThreeWvNebAzFl = link.set("footerTextTwo", {
            "text": "<p>This site works best if viewed with the latest version of Internet Explorer, Firefox, Chrome, or Safari browsers. For the best performance and security, always keep your web browser up-to-date.</p>",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6003, 9009, 9006, 9007, 9005, 9008, 9015, 9016])
            }
        });
        var footerTextFourWv = link.set("footerTextThree", {
            "text": 'We are committed to providing outstanding services for our applicants and members. If you require special assistance, including accommodations for disabilities or limited English proficiency, please call us at 800-982-8771 to request these free services.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6003, 9009])
            }
        });

        // IBC MBH / NAT ------------------------------------------------------------------------------------
        var footerTextOneIbcMbh = link.set("footerTextTwo", {
            "text": '<p>&reg; Highmark is a registered mark of Highmark Inc. </p>' +
            '<p>&copy; 2017 Highmark Inc., All Rights Reserved</p>',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9003])
            }
        });
        var footerTextTwoIbcmbh = link.set("footerTextThree", {
            "text": '<p>Independence Blue Cross and Highmark Blue Shield are independent licensees of the Blue Cross and Blue Shield Association.</p>' +
            '<p>Blue Cross, Blue Shield and the Cross and Shield symbols are registered service marks of the Blue Cross and Blue Shield Association.</p>' +
            '<p>Highmark is a registered mark of Highmark Inc.</p>',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9003])
            }
        });
        // Download Firefox ... IBC MBH/NAT
        var footerTextThreeIbcMbh = link.set("footerTextTwo", {
            "text": "<p>This site works best if viewed with the latest version of Internet Explorer, Firefox, Chrome, or Safari browsers. For the best performance and security, always keep your web browser up-to-date.</p>" ,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9003])
            }
        });

        // MN MBH  -  9004  ---------------------------------------------------------------------------------
        var footerTextOneMnMbh = link.set("footerTextThree", {
            "text": 'Blue Cross &reg; and Blue Shield &reg; of Minnesota and Blue Plus &reg; are nonprofit independent licensees of the Blue Cross and Blue Shield Association.',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9004])
            }
        });
        var footerTextTwoMnMbh = link.set("footerTextOne", {
            "text": "<p>This site works best if viewed with the latest version of Internet Explorer, Firefox, Chrome, or Safari browsers. For the best performance and security, always keep your web browser up-to-date.</p>",
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9004])
            }
        });

        // IBC 6008 -------------------------------------------------------------------------------------
        var footerTextOneIbc = link.set("footerTextThree", {
            "text": '<p>Independence Blue Cross is an independent licensee of the Blue Cross and Blue Shield Association.</p>' +
            '<p>These portal pages are licensed to Independence Blue Cross for its exclusive use.</p>',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6008])
            }
        });

        //  AHNJ  6009 -------------------------------------------------------------------------------------
        var footerTextOneAhnj = link.set("footerTextThree", {
            "text": '<p>We are committed to providing outstanding services for our applicants and members. If you require special assistance, including accommodations for disabilities or limited English proficiency, please call us at 1-866-681-7373 to request these free services</p>.' +
            '<p>AmeriHealth HMO, Inc. � QCC Insurance Company, d/b/a AmeriHealth Insurance Company. These portal pages are licensed to Amerihealth for its exclusive use.</p>', // jshint ignore: line
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6009])
            }
        });

        //  MN  6010, 9013 -------------------------------------------------------------------------------------
        var footerTextOneMn = link.set("footerTextThree", {
            "text": '<p>&copy;Blue Cross and Blue Shield of Minnesota. All rights reserved.</p>.' +
            '<p>Blue Cross&reg; and Blue Shield&reg; of Minnesota and Blue Plus&reg; are nonprofit independent licensees of the Blue Cross and Blue Shield Association.</p>',
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6010])
            }
        });


        //  END OF SET LINKS ///////////////////////////////////////////////////////////////////////////

        // var footerText = navigation.set("footerText");
        // footerText.linkFilters.push("portal", "brand");
        // footerText.links.push(footerTextOneWpaEtc, footerTextTwoWpaEtc, footerTextThreeWpaEtc, footerTextFourND,
        // 	footerTextOneWpaEtcWY, footerTextTwoWpaEtcWY, footerTextThreeWpaEtcWY, footerTextFourWpaEtcWY, footerTextOneWvNebAzFl, footerTextTwoWv, footerTextTwoNeb,footerTextTwoIdh, footerTextTwoFl, footerTextTwoAz, footerTextThreeWvNebAzFl, footerTextFourWv,
        // 	footerTextOneIbcMbh, footerTextTwoIbcmbh, footerTextThreeIbcMbh, footerTextOneMnMbh, footerTextTwoMnMbh, footerTextOneIbc,
        // 	footerTextOneAhnj, footerTextOneMn, footerTextTwoLa);

        var footerText = navigation.get("footerText") || navigation.set("footerText");
        if(footerText.length){
            footerText[0].linkFilters.splice(0,footerText[0].linkFilters.length);
            footerText[0].linkFilters.push('brand', 'portal');
            footerText[0].links.splice(0,footerText[0].links.length);
            footerText[0].links.push(footerTextOneWpaEtc, footerTextTwoWpaEtc, footerTextThreeWpaEtc, footerTextFourND,
                                     footerTextOneWpaEtcWY, footerTextTwoWpaEtcWY, footerTextThreeWpaEtcWY, footerTextFourWpaEtcWY, footerTextOneWvNebAzFl, footerTextTwoWv, footerTextTwoNeb,footerTextTwoIdh, footerTextTwoFl, footerTextTwoAz, footerTextThreeWvNebAzFl, footerTextFourWv,
                                     footerTextOneIbcMbh, footerTextTwoIbcmbh, footerTextThreeIbcMbh, footerTextOneMnMbh, footerTextTwoMnMbh, footerTextOneIbc,
                                     footerTextOneAhnj, footerTextOneMn, footerTextTwoLa);
        }
        else {
            footerText.linkFilters.splice(0,footerText.linkFilters.length);
            footerText.linkFilters.push('brand', 'portal');
            footerText.links.splice(0,footerText.links.length);
            footerText.links.push(footerTextOneWpaEtc, footerTextTwoWpaEtc, footerTextThreeWpaEtc, footerTextFourND,
                                  footerTextOneWpaEtcWY, footerTextTwoWpaEtcWY, footerTextThreeWpaEtcWY, footerTextFourWpaEtcWY, footerTextOneWvNebAzFl, footerTextTwoWv, footerTextTwoNeb,footerTextTwoIdh, footerTextTwoFl, footerTextTwoAz, footerTextThreeWvNebAzFl, footerTextFourWv,
                                  footerTextOneIbcMbh, footerTextTwoIbcmbh, footerTextThreeIbcMbh, footerTextOneMnMbh, footerTextTwoMnMbh, footerTextOneIbc,
                                  footerTextOneAhnj, footerTextOneMn, footerTextTwoLa);
        }


        // endregion

        // region Footer Items - Logo above the Social links ======================================

        var employerFooterLogoWpa = link.set("employerFooterLogoWpa", {
            "state": "home",
            "src": "footer/hmbcbs-logo-full.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9001])
            }
        });
        var employerFooterLogoWny = link.set("employerFooterLogoWny", {
            "state": "home",
            "src": "footer/HMWNY_footer.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9017])
            }
        });
        var employerFooterLogoNeny = link.set("employerFooterLogoNeny", {
            "state": "home",
            "src": "footer/HMNENY_footer.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9018])
            }
        });
        var employerFooterLogoCre = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/hbs-logo-full.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6002])
            }
        });
        var employerFooterLogoDe = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/hmbcbsde-logo-full.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6004, 9011])
            }
        });
        var employerFooterLogoWv = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/bcbswv-logo-full.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6003, 9009])
            }
        });
        var employerFooterLogoMn = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/bcbs-minnesota-logo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6010])
            }
        });
        var employerFooterLogoNd = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/BCBSND_white.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6011])
            }
        });
        var employerFooterLogoWy = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/bcbs-WYMlogo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6012])
            }
        });
        var employerFooterLogoFl = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/bcbs-florida-logo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9005])
            }
        });
        var employerFooterLogoAz = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/bcbs-arizona-logo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9007])
            }
        });
        var employerFooterLogoNeb = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/bcbs-nebraska-logo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9006])
            }
        });
        var employerFooterLogoMnMbh = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/bcbs-minnesota-logo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9004])
            }
        });
        var employerFooterLogoIbcMbh = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/bc-independence-logo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9003])
            }
        });
        var employerFooterLogoIbc = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/ibx-logo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6008])
            }
        });
        var employerFooterLogoAhnj = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/ameriHealth.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([6009])
            }
        });
        var employerFooterLogoIdh = link.set("employerFooterLogo", {
            "state": "home",
            "src": "footer/idaho-logo.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9015])
            }
        });
        var employerFooterLogoLa = link.set("employerFooterLogoLa", {
            "state": "home",
            "src": "footer/hmhsla-logo-footer.png",
            "description": "Company Logo",
            "newWindow": false,
            "filterData": {
                "portal": "employer",
                "brand": mapUBKs([9016])
            }
        });

        // var footerLogo = navigation.set("footerLogo");
        // footerLogo.linkFilters.push("portal", "brand", "crazyClientsPage");
        // footerLogo.links.push(
        // 	employerFooterLogoWpa, employerFooterLogoCre, employerFooterLogoDe, employerFooterLogoWv,
        // 	employerFooterLogoMn, employerFooterLogoFl, employerFooterLogoAz, employerFooterLogoNeb,
        // 	employerFooterLogoMnMbh, employerFooterLogoIbcMbh, employerFooterLogoIbc, employerFooterLogoAhnj,
        // 	employerFooterLogoNd, employerFooterLogoWy, employerFooterLogoIdh, employerFooterLogoLa
        // );
        var footerLogo = navigation.get("footerLogo") || navigation.set("footerLogo");
        if(footerLogo.length){
            footerLogo[0].linkFilters.splice(0,footerLogo[0].linkFilters.length);
            footerLogo[0].linkFilters.push("portal", "brand", "crazyClientsPage");
            footerLogo[0].links.splice(0,footerLogo[0].links.length);
            footerLogo[0].links.push(employerFooterLogoWpa, employerFooterLogoCre, employerFooterLogoDe, employerFooterLogoWv,
                                     employerFooterLogoMn, employerFooterLogoFl, employerFooterLogoAz, employerFooterLogoNeb,
                                     employerFooterLogoMnMbh, employerFooterLogoIbcMbh, employerFooterLogoIbc, employerFooterLogoAhnj,
                                     employerFooterLogoNd, employerFooterLogoWy, employerFooterLogoIdh, employerFooterLogoLa, employerFooterLogoNeny, employerFooterLogoWny);
        }
        else {
            footerLogo.linkFilters.splice(0,footerLogo.linkFilters.length);
            footerLogo.linkFilters.push("portal", "brand", "crazyClientsPage");
            footerLogo.links.splice(0,footerLogo.links.length);
            footerLogo.links.push(employerFooterLogoWpa, employerFooterLogoCre, employerFooterLogoDe, employerFooterLogoWv,
                                  employerFooterLogoMn, employerFooterLogoFl, employerFooterLogoAz, employerFooterLogoNeb,
                                  employerFooterLogoMnMbh, employerFooterLogoIbcMbh, employerFooterLogoIbc, employerFooterLogoAhnj,
                                  employerFooterLogoNd, employerFooterLogoWy, employerFooterLogoIdh, employerFooterLogoLa, employerFooterLogoNeny, employerFooterLogoWny);
        }


        // var socialLinksHMHS = navigation.set("socialLinksHMHS");
        // socialLinksHMHS.linkFilters.push("brand", "tempPassword", function (link) {
        // 	link.newWindow = false;
        // 	return link;
        // });
        // socialLinksHMHS.links.push(
        // 	link.get('Facebook'), link.get('Twitter'), link.get('YouTube'), link.get('Pinterest'), link.get('LinkedIn'),
        // 	link.get('FacebookMN'), link.get('TwitterMN'), link.get('LinkedInMN'), link.get('FacebookND'),
        // 	link.get('TwitterND'), link.get('LinkedInND'), link.get('YouTubeND'), link.get('FacebookWY'),
        // 	link.get('TwitterWY'), link.get('LinkedInWY'), link.get('YouTubeWY')
        // );
        var socialLinksHMHS = navigation.get("socialLinksHMHS") || navigation.set("socialLinksHMHS");
        if(socialLinksHMHS.length){
            socialLinksHMHS[0].linkFilters.splice(0,socialLinksHMHS[0].linkFilters.length);
            socialLinksHMHS[0].linkFilters.push("brand", "tempPassword", function (link) {
                link.newWindow = false;
                return link;
            });
            socialLinksHMHS[0].links.splice(0,socialLinksHMHS[0].links.length);
            socialLinksHMHS[0].links.push(link.get('Facebook'), link.get('Twitter'), link.get('YouTube'), link.get('Pinterest'), link.get('LinkedIn'),
                                          link.get('FacebookMN'), link.get('TwitterMN'), link.get('LinkedInMN'), link.get('FacebookND'),
                                          link.get('TwitterND'), link.get('LinkedInND'), link.get('YouTubeND'), link.get('FacebookWY'),
                                          link.get('TwitterWY'), link.get('LinkedInWY'), link.get('YouTubeWY'), link.get('FacebookNENY'), link.get('TwitterNENY'), link.get('YouTubeNENY'), link.get('InstaGramNENY'), link.get('FacebookWNY')
                                          ,link.get('TwitterWNY'), link.get('YouTubeWNY'), link.get('LinkedInWNY'), link.get('InstaGramWNY'));
        }
        else {
            socialLinksHMHS.linkFilters.splice(0,socialLinksHMHS.linkFilters.length);
            socialLinksHMHS.linkFilters.push("brand", "tempPassword", function (link) {
                link.newWindow = false;
                return link;
            });
            socialLinksHMHS.links.splice(0,socialLinksHMHS.links.length);
            socialLinksHMHS.links.push(link.get('Facebook'), link.get('Twitter'), link.get('YouTube'), link.get('Pinterest'), link.get('LinkedIn'),
                                       link.get('FacebookMN'), link.get('TwitterMN'), link.get('LinkedInMN'), link.get('FacebookND'),
                                       link.get('TwitterND'), link.get('LinkedInND'), link.get('YouTubeND'), link.get('FacebookWY'),
                                       link.get('TwitterWY'), link.get('LinkedInWY'), link.get('YouTubeWY'), link.get('FacebookNENY'), link.get('TwitterNENY'), link.get('YouTubeNENY'), link.get('InstaGramNENY'), link.get('FacebookWNY')
                                       ,link.get('TwitterWNY'), link.get('YouTubeWNY'), link.get('LinkedInWNY'), link.get('InstaGramWNY'));
        }

        // endregion

        // region Large collapsed region to be sorted out and labeled later  ============

        // MENU SETUP.  AKA NAV BAR ============================================================

        var employerEntitlementFilter = navigation.setFilter("employerEntitlement", function (item) { // jshint ignore: line
            // If link has entitlement property
            if (item.filterData && item.filterData.entitlement) {
                if (item.filterData.entitlement === '*') {
                    return true;
                }
                return eval(item.filterData.entitlement); // jshint ignore:line
            }
            // If link didn't have entitlement property, always pass filter
            return true;
        });

        // var logo = navigation.set("logo");
        // logo.linkFilters.push("portal", "postPassword", "crazyClientsPage");
        // logo.links.push(preLoginLogo, employerLogo);
        var logo = navigation.get("logo") || navigation.set("logo");
        if(logo.length){
            logo[0].linkFilters.splice(0,logo[0].linkFilters.length);
            logo[0].linkFilters.push("portal", "postPassword", "crazyClientsPage");
            logo[0].links.splice(0,logo[0].links.length);
            logo[0].links.push(preLoginLogo, employerLogo);
        }
        else {
            logo.linkFilters.splice(0,logo.linkFilters.length);
            logo.linkFilters.push("portal", "postPassword", "crazyClientsPage");
            logo.links.splice(0,logo.links.length);
            logo.links.push(preLoginLogo, employerLogo);
        }

        // BREAD CRUMBS
        navigation.setFilter('displayInThisPage', function (item) {
            return (
                item.id == "searchBreadcrumb" &&
                $state &&
                $state.current &&
                (
                    ($state.current.url && $state.current.url.indexOf("plan-admin-list") > -1) ||
                    ($state.current.name && $state.current.name.indexOf("add-plan-admin") > -1)
                )
            );
        });
        navigation.setFilter('displayInThisPageMCU', function (item) {
            return (
                item.id == "switchClient" &&
                $state &&
                $state.current &&
                (
                    ($state.current.url && $state.current.url.indexOf("profile") > -1) || ($state.current.url && $state.current.url.indexOf("pa-change-password") > -1)
                )
            );
        });

        var searchBreadcrumb = link.set("searchBreadcrumb", {
            label: "Search",
            state: "client-search",
            newWindow: false,
            filterData: {
                brand: ['*'],
                postPassword: true,
                portal: "employer",
                entitlement: '*'
            }
        });
        var switchClient = link.set("switchClient", {
            label: "Switch Client",
            state: "clientselection",
            newWindow: false,
            filterData: {
                brand: mapUBKs([6010, 6011,6001,9001,9011,9009,9017,9018,6002]),
                postPassword: true,
                portal: "employer",
                entitlement: 'sessionData.basicInfo.role.toLowerCase().indexOf("mcu_admin") >= 0'
            }
        });

        var changePasswordLink = link.set("employerChangePassword", {
            "label": "Change Password",
            "state": "employer-change-password",
            "rootState": "changePassword",
            "filterData": {
                "brand": ["*"],
                "portal": "employer",
                "postPassword": true,
                "tempPassword": true
            }
        });

        var breadCrumbHome = navigation.set("breadCrumbHome");
        if(sessionData.basicInfo.role.toLowerCase().indexOf("mcu_admin") < 0) {
            breadCrumbHome.linkFilters.push("brand","displayInThisPage");
       }
       else
        {
            breadCrumbHome.linkFilters.push("brand","displayInThisPageMCU");
        }
        breadCrumbHome.links.push(switchClient,searchBreadcrumb);

        navigation.setFilter("crazyClientsPage", function (item) {
            if ($state.current.name === "clients") {
                if (item.id == "employerPostPasswordHome") {
                    item.state = "clients";
                    return item;
                }
                if (item.id == "employerFooterLogo") {
                    item.state = "clients";
                    return item;
                }
                if (item.id == "preLoginLogo") {
                    item.state = "clients";
                    return item;
                }
                if (item.id == "clientLogo") {
                    item.state = "clients";
                    return item;
                }
                return false;
            }
            return true;
        });


        // HEADER TABS ---- the dark blue, 100% width bar
        // var headerTabs = navigation.set("headerTabs");
        // headerTabs.linkFilters.push("brand", "postPassword", "portal", "employerEntitlement", "tempPassword", "crazyClientsPage");
        // headerTabs.links.push(
        // 	employerPostPasswordHomeLink, enrollmentLink, groupsAndClients,
        // 	assistEmployeesLink, billingLink, reportsLink, resourcesLink,
        // 	changePasswordLink
        // );
        var headerTabs = navigation.get("headerTabs") || navigation.set("headerTabs");
        if(headerTabs.length){
            headerTabs[0].linkFilters.splice(0,headerTabs[0].linkFilters.length);
            headerTabs[0].linkFilters.push("brand", "postPassword", "portal", "employerEntitlement", "tempPassword", "crazyClientsPage");
            headerTabs[0].links.splice(0,headerTabs[0].links.length);
            headerTabs[0].links.push(
                employerPostPasswordHomeLink, enrollmentLink, groupsAndClients,
                assistEmployeesLink, billingLink, reportsLink, resourcesLink,
                changePasswordLink
            );

        }
        else {
            headerTabs.linkFilters.splice(0,headerTabs.linkFilters.length);
            headerTabs.linkFilters.push("brand", "postPassword", "portal", "employerEntitlement", "tempPassword", "crazyClientsPage");
            headerTabs.links.splice(0,headerTabs.links.length);
            headerTabs.links.push(
                employerPostPasswordHomeLink, enrollmentLink, groupsAndClients,
                assistEmployeesLink, billingLink, reportsLink, resourcesLink,
                changePasswordLink
            );
        }

        // QUICKLINKS - The gold ribbon that's conditionally shown on the banner
        // var quickLinks = navigation.set('quickLinks');
        // quickLinks.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
        // quickLinks.links.push(addEmployeeLink, findEmployeeLink, enrollmentsInProcessLink, idCardsLink, groupContractsLinkQL, masterGroupContractsLinkQL, benefitBookletsLinkQL);
        var quickLinks = navigation.get("quickLinks") || navigation.set("quickLinks");
        if(quickLinks.length){
            quickLinks[0].linkFilters.splice(0,quickLinks[0].linkFilters.length);
            quickLinks[0].linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            quickLinks[0].links.splice(0,quickLinks[0].links.length);
            quickLinks[0].links.push(addEmployeeLink, findEmployeeLink, enrollmentsInProcessLink, idCardsLink, groupContractsLinkQL, masterGroupContractsLinkQL, benefitBookletsLinkQL);
        }
        else {
            quickLinks.linkFilters.splice(0,quickLinks.linkFilters.length);
            quickLinks.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            quickLinks.links.splice(0,quickLinks.links.length);
            quickLinks.links.push(addEmployeeLink, findEmployeeLink, enrollmentsInProcessLink, idCardsLink, groupContractsLinkQL, masterGroupContractsLinkQL, benefitBookletsLinkQL);
        }

        // ENROLLMENT
        // var enrollmentTutorial = navigation.set('enrollmentTutorial');
        // enrollmentTutorial.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
        // enrollmentTutorial.links.push(enrollmentTutorialLink, enrollmentTutorialLink_IBC, enrollmentTutorialLink_AHNJ,enrollmentTutorialLink_Wyoming, enrollmentTutorialLink_NorthDakota);
        var enrollmentTutorial = navigation.get("enrollmentTutorial") || navigation.set("enrollmentTutorial");
        if(enrollmentTutorial.length){
            enrollmentTutorial[0].linkFilters.splice(0,enrollmentTutorial[0].linkFilters.length);
            enrollmentTutorial[0].linkFilters.push('brand', 'portal', 'postPassword', 'employerEntitlement');
            enrollmentTutorial[0].links.splice(0,enrollmentTutorial[0].links.length);
            //added the correct links for showing correct label instead of "e"
            enrollmentTutorial[0].links.push(enrollmentTutorialLink, enrollmentTutorialLink_IBC, enrollmentTutorialLink_AHNJ,enrollmentTutorialLink_Wyoming, enrollmentTutorialLink_NorthDakota);
        }
        else {
            enrollmentTutorial.linkFilters.splice(0,enrollmentTutorial.linkFilters.length);
            enrollmentTutorial.linkFilters.push('brand', 'portal', 'postPassword', 'employerEntitlement');
            enrollmentTutorial.links.splice(0,enrollmentTutorial.links.length);
            enrollmentTutorial.links.push(enrollmentTutorialLink, enrollmentTutorialLink_IBC, enrollmentTutorialLink_AHNJ,enrollmentTutorialLink_Wyoming, enrollmentTutorialLink_NorthDakota);
        }


        /* begin ASSIST EMPLOYEES LANDING LINKS */
        // var employeeResources = navigation.set('employeeResources');
        // employeeResources.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
        // employeeResources.links.push(idCardsLink, claimsLink, benefitBookletsLink, benefitBookletsWYLink, summaryOfBenefitsLink, summaryOfBenefitsWYLink, groupContractsLink, groupContractsWYLink, coveredDrugsFormularyList, PreventiveCareBenefitsListLink, masterGroupContractsLink, preventiveMedicationsLink);
        var employeeResources = navigation.get("employeeResources") || navigation.set("employeeResources");
        if(employeeResources.length){
            employeeResources[0].linkFilters.splice(0,employeeResources[0].linkFilters.length);
            employeeResources[0].linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            employeeResources[0].links.splice(0,employeeResources[0].links.length);
            employeeResources[0].links.push(idCardsLink, claimsLink, benefitBookletsLink, benefitBookletsWYLink, summaryOfBenefitsLink, summaryOfBenefitsWYLink, groupContractsLink, groupContractsWYLink, coveredDrugsFormularyList, PreventiveCareBenefitsListLink, masterGroupContractsLink, preventiveMedicationsLink);
        }
        else {
            employeeResources.linkFilters.splice(0,employeeResources.linkFilters.length);
            employeeResources.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            employeeResources.links.splice(0,employeeResources.links.length);
            employeeResources.links.push(idCardsLink, claimsLink, benefitBookletsLink, benefitBookletsWYLink, summaryOfBenefitsLink, summaryOfBenefitsWYLink, groupContractsLink, groupContractsWYLink, coveredDrugsFormularyList, PreventiveCareBenefitsListLink, masterGroupContractsLink, preventiveMedicationsLink);
        }



        // var providers = navigation.set('providers');
        // providers.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
        // providers.links.push(findAProviderLink, findAProviderMNLink, findADentistNDLink, findADentistWYLink, findADoctorNDLink, findADoctorWYLink, findAProviderLink_ibc, findAProviderLink_ahnj, visionProviderLink, findanEyecareProviderNDLink, findanEyecareProviderWYLink, dentalProviderLink, changePCPLink, findAPharmacyWYLink);
        var providers = navigation.get("providers") || navigation.set("providers");
        if(providers.length){
            providers[0].linkFilters.splice(0,providers[0].linkFilters.length);
            providers[0].linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            providers[0].links.splice(0,providers[0].links.length);
            providers[0].links.push(findAProviderLink, findAProviderWNYLink,findAProviderNENYLink,findAProviderMNLink, findADentistNDLink, findADentistWYLink, findADoctorNDLink, findADoctorWYLink, findAProviderLink_ibc, findAProviderLink_ahnj, visionProviderLink, findanEyecareProviderNDLink, findanEyecareProviderWYLink, dentalProviderLink, changePCPLink, findAPharmacyWYLink);
        }
        else {
            providers.linkFilters.splice(0,providers.linkFilters.length);
            providers.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            providers.links.splice(0,providers.links.length);
            providers.links.push(findAProviderLink,findAProviderWNYLink, findAProviderNENYLink,findAProviderMNLink, findADentistNDLink, findADentistWYLink, findADoctorNDLink, findADoctorWYLink, findAProviderLink_ibc, findAProviderLink_ahnj, visionProviderLink, findanEyecareProviderNDLink, findanEyecareProviderWYLink, dentalProviderLink, changePCPLink, findAPharmacyWYLink);
        }


        // var spendingAccount = navigation.set('spendingAccount');
        // spendingAccount.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
        // spendingAccount.links.push(
        //    acclarisSpendingAccountLink, alegeusSpendingAccountLink,
        // 	spendingAccountReportGuideLink_wpa, spendingAccountReportGuideLink_wv,
        // 	spendingAccountReportGuideLink_mbh, spendingAccountReportGuideLink_de, spendingAccountReportGuideLink_cpa,
        // 	spendingAccountReportGuideLink_mbhMn, spendingAccountReportGuideLink_mbhibc,
        // 	manageSpendingAccountElectionsLink,
        // 	eligibleExpensesLink,
        // 	onlineAnswersAndHowTosLink, onlineAnswersAndHowTosLink_mbh
        // );
        var spendingAccount = navigation.get("spendingAccount") || navigation.set("spendingAccount");
        if(spendingAccount.length){
            spendingAccount[0].linkFilters.splice(0,spendingAccount[0].linkFilters.length);
            spendingAccount[0].linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            spendingAccount[0].links.splice(0,spendingAccount[0].links.length);
            spendingAccount[0].links.push(alegeusSpendingAccountLink,
                                          spendingAccountReportGuideLink_wpa, spendingAccountReportGuideLink_wv,
                                          spendingAccountReportGuideLink_mbh, spendingAccountReportGuideLink_de, spendingAccountReportGuideLink_cpa,
                                          spendingAccountReportGuideLink_mbhMn, spendingAccountReportGuideLink_mbhibc,
                                          manageSpendingAccountElectionsLink,
                                          eligibleExpensesLink,
                                          onlineAnswersAndHowTosLink, onlineAnswersAndHowTosLink_mbh);
        }
        else {
            spendingAccount.linkFilters.splice(0,spendingAccount.linkFilters.length);
            spendingAccount.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            spendingAccount.links.splice(0,spendingAccount.links.length);
            spendingAccount.links.push(alegeusSpendingAccountLink,
                                       spendingAccountReportGuideLink_wpa, spendingAccountReportGuideLink_wv,
                                       spendingAccountReportGuideLink_mbh, spendingAccountReportGuideLink_de, spendingAccountReportGuideLink_cpa,
                                       spendingAccountReportGuideLink_mbhMn, spendingAccountReportGuideLink_mbhibc,
                                       manageSpendingAccountElectionsLink,
                                       eligibleExpensesLink,
                                       onlineAnswersAndHowTosLink, onlineAnswersAndHowTosLink_mbh);
        }

        // var educationalTools = navigation.set('educationalTools');
        // educationalTools.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
        // educationalTools.links.push(
        // 	consumerCommunicationToolkitLink_wpa, consumerCommunicationToolkitLink_wv, consumerCommunicationToolkitLink_de,
        // 	consumerCommunicationToolkitLink_cpa, consumerCommunicationToolkitLink_mbh,
        // 	secondOpinionHealthEducationLink, memberResourceGuideLink
        // );
        var educationalTools = navigation.get("educationalTools") || navigation.set("educationalTools");
        if(educationalTools.length){
            educationalTools[0].linkFilters.splice(0,educationalTools[0].linkFilters.length);
            educationalTools[0].linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            educationalTools[0].links.splice(0,educationalTools[0].links.length);
            educationalTools[0].links.push(
                // secondOpinionHealthEducationLink, 
                memberResourceGuideLink);
        }
        else {
            educationalTools.linkFilters.splice(0,educationalTools.linkFilters.length);
            educationalTools.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            educationalTools.links.splice(0,educationalTools.links.length);
            educationalTools.links.push(
                // secondOpinionHealthEducationLink,
                 memberResourceGuideLink);
        }
        /* end ASSIST EMPLOYEES LANDING LINKS */

        // var findAProvider = navigation.set('findAProvider');
        // findAProvider.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
        // findAProvider.links.push(findAProviderLink, findAProviderMNLink, findADentistNDLink, findADentistWYLink, findADoctorNDLink, findADoctorWYLink, findAProviderLink_ibc, findAProviderLink_ahnj, findAPharmacyWYLink);
        var findAProvider = navigation.get("findAProvider") || navigation.set("findAProvider");
        if(findAProvider.length){
            findAProvider[0].linkFilters.splice(0,findAProvider[0].linkFilters.length);
            findAProvider[0].linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            findAProvider[0].links.splice(0,findAProvider[0].links.length);
            findAProvider[0].links.push(findAProviderLink, findAProviderWNYLink, findAProviderNENYLink,findAProviderMNLink, findADentistNDLink, findADentistWYLink, findADoctorNDLink, findADoctorWYLink, findAProviderLink_ibc, findAProviderLink_ahnj, findAPharmacyWYLink);
        }
        else {
            findAProvider.linkFilters.splice(0,findAProvider.linkFilters.length);
            findAProvider.linkFilters.push('brand', 'postPassword', 'portal', 'employerEntitlement');
            findAProvider.links.splice(0,findAProvider.links.length);
            findAProvider.links.push(findAProviderLink,findAProviderWNYLink, findAProviderNENYLink, findAProviderMNLink, findADentistNDLink, findADentistWYLink, findADoctorNDLink, findADoctorWYLink, findAProviderLink_ibc, findAProviderLink_ahnj, findAPharmacyWYLink);
        }
        // endregion

        // region  navigation.set methods that could be moved closer to thier link objects ====
        // var greyNav = navigation.set('greyNav');
        // greyNav.linkFilters.push('brand', 'portal', 'postPassword');
        // greyNav.links.push(emailGreyLink);
        var greyNav = navigation.get("greyNav") || navigation.set("greyNav");
        if(greyNav.length){
            greyNav[0].linkFilters.splice(0,greyNav[0].linkFilters.length);
            greyNav[0].linkFilters.push('brand', 'portal', 'postPassword');
            greyNav[0].links.splice(0,greyNav[0].links.length);
            greyNav[0].links.push(emailGreyLink);
        }
        else {
            greyNav.linkFilters.splice(0,greyNav.linkFilters.length);
            greyNav.linkFilters.push('brand', 'portal', 'postPassword');
            greyNav.links.splice(0,greyNav.links.length);
            greyNav.links.push(emailGreyLink);
        }


        var centerHeader = navigation.get("centerHeader") || navigation.set("centerHeader");
        if(centerHeader.length){
            centerHeader[0].linkFilters.splice(0,centerHeader[0].linkFilters.length);
            centerHeader[0].linkFilters.push("portal", "postPassword");
            centerHeader[0].links.splice(0,centerHeader[0].links.length);
            centerHeader[0].links.push(title);
        }
        else {
            centerHeader.linkFilters.splice(0,centerHeader.linkFilters.length);
            centerHeader.linkFilters.push("portal", "postPassword");
            centerHeader.links.splice(0,centerHeader.links.length);
            centerHeader.links.push(title);
        }


        var loginTime = navigation.get("loginTime") || navigation.set("loginTime");
        if(loginTime.length){
            loginTime[0].linkFilters.splice(0,loginTime[0].linkFilters.length);
            loginTime[0].linkFilters.push("portal", "postPassword");
            loginTime[0].links.splice(0,loginTime[0].links.length);
            loginTime[0].links.push(loginLink);
        }
        else {
            loginTime.linkFilters.splice(0,loginTime.linkFilters.length);
            loginTime.linkFilters.push("portal", "postPassword");
            loginTime.links.splice(0,loginTime.links.length);
            loginTime.links.push(loginLink);
        }



        var userTabs = navigation.get("userTabs") || navigation.set("userTabs");
        if(userTabs.length){
            userTabs[0].linkFilters.splice(0,userTabs[0].linkFilters.length);
            userTabs[0].linkFilters.push("brand","portal", "postPassword",'employerEntitlement');
            userTabs[0].links.splice(0,userTabs[0].links.length);
            userTabs[0].links.push(profileUser, clientSelection);
        }
        else {
            userTabs.linkFilters.splice(0,userTabs.linkFilters.length);
            userTabs.linkFilters.push("brand","portal", "postPassword",'employerEntitlement',"crazyClientsPage");
            userTabs.links.splice(0,userTabs.links.length);
            userTabs.links.push(profileUser, clientSelection);
        }



        var memberPrePasswordHomeLink = link.set("memberPrePasswordHome", {
            "label": "Home",
            "url": "/",
            "filterData": {
                "brand": ['*'],
                "portal": "employer"
            }
        });

        // var postLogoutUrl = navigation.set("postLogoutUrl");
        // postLogoutUrl.linkFilters.push("brand", "portal");
        // postLogoutUrl.links.push(memberPrePasswordHomeLink);
        var postLogoutUrl = navigation.get("postLogoutUrl") || navigation.set("postLogoutUrl");
        if(postLogoutUrl.length){
            postLogoutUrl[0].linkFilters.splice(0,postLogoutUrl[0].linkFilters.length);
            postLogoutUrl[0].linkFilters.push("brand", "portal");
            postLogoutUrl[0].links.splice(0,postLogoutUrl[0].links.length);
            postLogoutUrl[0].links.push(memberPrePasswordHomeLink);
        }
        else {
            postLogoutUrl.linkFilters.splice(0,postLogoutUrl.linkFilters.length);
            postLogoutUrl.linkFilters.push("brand", "portal");
            postLogoutUrl.links.splice(0,postLogoutUrl.links.length);
            postLogoutUrl.links.push(memberPrePasswordHomeLink);
        }
        // endregion

    }
    function setMCUEmployerLinks() {
        var mapUBKs = brandConfig.mapLeafUBKsToSharedBrandCodes.bind(brandConfig);

        // region LINKS, Blue Nav Bar and others ====================================================

        var preLoginLogo = link.set("preLoginLogo", {
            "state": "login",
            "filterData": {
                "postPassword": false,
                "portal": "employer"
            }
        });

        var employerLogo = link.set("clientLogo", {
            "state": "home",
            "filterData": {
                "postPassword": true,
                "portal": "employer"
            }
        });

        var title = link.set("title", {
            "type": "title",
            "title": "Employer Portal",
            "filterData": {
                "postPassword": true,
                "portal": "employer"
            }
        });

        /*
         * User Links
         */
        var loginLink = link.set("loginLink", {
            "display": true,
            "filterData": {
                "postPassword": true,
                "portal": "employer"
            }
        });
        var memberPrePasswordHomeLink = link.set("memberPrePasswordHome", {
            "label": "Home",
            "url": "/",
            "filterData": {
                "brand": ['*'],
                "portal": "employer"
            }
        });

        navigation.setFilter("crazyClientsPage", function (item) {
            if ($state.current.name === "clients") {
                if (item.id == "employerPostPasswordHome") {
                    item.state = "clients";
                    return item;
                }
                if (item.id == "employerFooterLogo") {
                    item.state = "clients";
                    return item;
                }
                if (item.id == "preLoginLogo") {
                    item.state = "clients";
                    return item;
                }
                if (item.id == "clientLogo") {
                    item.state = "clients";
                    return item;
                }
                return false;
            }
            return true;
        });

        var employerEntitlementFilter = navigation.setFilter("employerEntitlement", function (item) { // jshint ignore: line
            if (item.filterData && item.filterData.entitlement) {
                if (item.filterData.entitlement === '*') {
                    return true;
                }
                return eval(item.filterData.entitlement); // jshint ignore:line
            }
            return true;
        });
        var profileUser = link.set("profileUser", {
            "state": "profile",
            "label": "Profile",
            "filterData": {
                "brand": ['*'],
                "postPassword": true,
                "admin": true,
                "portal": "employer"
            }
        });
        var clientSelection = link.set("clientSelection", {
            "state": "clientselection",
            "label": "Switch Client",
            "filterData": {
                "brand": mapUBKs([6010, 6011,6001,9001,9011,9009,9017,9018,6002]),
                "postPassword": true,
                "admin": true,
                "portal": "employer",
                "entitlement": 	"sessionData.isClientselection"
            }
        });


        var userTabs = navigation.get("userTabs") || navigation.set("userTabs");
        if(userTabs.length){
            userTabs[0].linkFilters.splice(0,userTabs[0].linkFilters.length);
            userTabs[0].linkFilters.push("brand","portal", "postPassword",'employerEntitlement');
            userTabs[0].links.splice(0,userTabs[0].links.length);
            userTabs[0].links.push(profileUser, clientSelection);
        }
        else {
            userTabs.linkFilters.splice(0,userTabs.linkFilters.length);
            userTabs.linkFilters.push("brand","portal", "postPassword",'employerEntitlement');
            userTabs.links.splice(0,userTabs.links.length);
            userTabs.links.push(profileUser, clientSelection);
        }


        var logo = navigation.get("logo") || navigation.set("logo");
        if(logo.length){
            logo[0].linkFilters.splice(0,logo[0].linkFilters.length);
            logo[0].linkFilters.push("portal", "postPassword", "crazyClientsPage");
            logo[0].links.splice(0,logo[0].links.length);
            logo[0].links.push(preLoginLogo, employerLogo);
        }
        else {
            logo.linkFilters.splice(0,logo.linkFilters.length);
            logo.linkFilters.push("portal", "postPassword", "crazyClientsPage");
            logo.links.splice(0,logo.links.length);
            logo.links.push(preLoginLogo, employerLogo);
        }


        var postLogoutUrl = navigation.get("postLogoutUrl") || navigation.set("postLogoutUrl");
        if(postLogoutUrl.length){
            postLogoutUrl[0].linkFilters.splice(0,postLogoutUrl[0].linkFilters.length);
            postLogoutUrl[0].linkFilters.push("brand", "portal");
            postLogoutUrl[0].links.splice(0,postLogoutUrl[0].links.length);
            postLogoutUrl[0].links.push(memberPrePasswordHomeLink);
        }
        else {
            postLogoutUrl.linkFilters.splice(0,postLogoutUrl.linkFilters.length);
            postLogoutUrl.linkFilters.push("brand", "portal");
            postLogoutUrl.links.splice(0,postLogoutUrl.links.length);
            postLogoutUrl.links.push(memberPrePasswordHomeLink);
        }

        var switchClientMCU = link.set("switchClientMCU", {
            label: "Switch Client",
            state: "clientselection",
            newWindow: false,
            filterData: {
                brand: mapUBKs([6010, 6011,6001,9001,9011,9009,9017,9018,6002]),
                postPassword: true,
                portal: "employer",
                entitlement: '*'
            }
        });
        navigation.setFilter('MCUdisplayInThisPage', function (item) {
            return (
                item.id == "switchClientMCU" &&
                $state &&
                $state.current &&
                (
                    ($state.current.url && $state.current.url.indexOf("profile") > -1) || ($state.current.url && $state.current.url.indexOf("pa-change-password") > -1)
                )
            );
        });


        var breadCrumbHome = navigation.get("breadCrumbHome") || navigation.set("breadCrumbHome");
        if(breadCrumbHome.length){
            breadCrumbHome[0].linkFilters.splice(0,breadCrumbHome[0].linkFilters.length);
            breadCrumbHome[0].linkFilters.push("brand","MCUdisplayInThisPage");
            breadCrumbHome[0].links.splice(0,breadCrumbHome[0].links.length);
            breadCrumbHome[0].links.push(switchClientMCU);
        }
        else {
            breadCrumbHome.linkFilters.splice(0,breadCrumbHome.linkFilters.length);
            breadCrumbHome.linkFilters.push("brand","MCUdisplayInThisPage");
            breadCrumbHome.links.splice(0,breadCrumbHome.links.length);
            breadCrumbHome.links.push(switchClientMCU);
        }



    }
}]);
